export default {
    "en": {
        "removeTextFromImage": {
            "title": "Free AI Text Remover - Remove Text from Image | WeryAI",
            "description": "Remove text, watermarks, date stamps, and logos from any image with AI inpainting. Clean results that preserve the original background. Free credits, no card needed.",
            "keywords": "remove text from image, ai text remover, remove date stamp, remove watermark online, cleanup pictures, ai inpainting, remove logo from photo",
            "og_title": "Free AI Text Remover - Remove Text from Image | WeryAI",
            "og_description": "Remove text, watermarks, date stamps, and logos from any image with AI inpainting. Clean results that preserve the original background. Free credits, no card needed.",
            "twitter_title": "Free AI Text Remover - Remove Text from Image | WeryAI",
            "twitter_description": "Remove text, watermarks, date stamps, and logos from any image with AI inpainting. Clean results that preserve the original background. Free credits, no card needed.",
            "page": {
                "title1": "Remove Text from Images Instantly",
                "title2": "Remove text from image, erase watermarks, delete date stamps, and clear logos without blurring the background. WeryAI uses AI inpainting to rebuild the missing area so your image stays clean and natural.",
                "faq": [
                    {
                        "question": "What is an AI text remover?",
                        "answer": "An AI text remover is a tool that removes text from images, watermarks, logos, and captions while rebuilding the background with AI inpainting. It helps you clean up photos without leaving blur or obvious editing marks."
                    },
                    {
                        "question": "How do I remove text from an image without blurring it?",
                        "answer": "Use WeryAI's AI Text Remover. Instead of covering text with blur, our AI analyzes the surrounding pixels and fills the removed area naturally. Need to translate text instead of removing it? Try our <a href=\"/image-text-translate\">Image Text Translator</a>."
                    },
                    {
                        "question": "Can I remove watermarks and logos from images?",
                        "answer": "Yes. You can remove watermarks, logos, labels, subtitles, and other text overlays from images. This works well for product photos, screenshots, social posts, and scanned pictures."
                    },
                    {
                        "question": "Can I remove date stamps from photos?",
                        "answer": "Yes. Date stamps are one of the most common use cases. AI can detect the digital numbers and remove them while restoring the sky, grass, skin, or other background details behind them."
                    },
                    {
                        "question": "Can I use WeryAI AI Text Remover for free?",
                        "answer": "Yes. New users get free credits on signup with no credit card required. You can also earn more free credits through daily check-in, completing tasks, and inviting friends, so you can keep using the tool without an upfront payment."
                    }
                ]
            },
            "faq": [
                {
                    "question": "What is an AI text remover?",
                    "answer": "An AI text remover is a tool that removes text from images, watermarks, logos, and captions while rebuilding the background with AI inpainting."
                },
                {
                    "question": "How do I remove text from an image without blurring it?",
                    "answer": "Use WeryAI's AI Text Remover. AI analyzes the surrounding pixels and fills the removed area naturally instead of covering it with blur."
                },
                {
                    "question": "Can I remove watermarks and logos from images?",
                    "answer": "Yes. You can remove watermarks, logos, labels, subtitles, and other text overlays from images while keeping the background clean."
                }
            ],
            "feature_title1": "Remove Watermarks with One Click",
            "feature_desc1": "Erase watermarks, logos, and branded overlays from images without damaging the original photo. Perfect for product visuals, screenshots, and marketing assets.",
            "feature_title2": "Delete Date Stamps & Captions",
            "feature_desc2": "Remove date stamps, timestamps, subtitles, usernames, and other distracting text from travel photos, old family pictures, and social media images.",
            "feature_title3": "AI Inpainting That Rebuilds Backgrounds",
            "feature_desc3": "WeryAI does more than blur text. AI inpainting recreates grass, sky, fabric, walls, and other textures behind the removed text so the final image looks clean and natural.",
            "howto": {
                "name": "How to Remove Text from Image Online",
                "step1": {
                    "name": "Upload Image",
                    "text": "Upload an image that contains text, a watermark, a logo, or a date stamp."
                },
                "step2": {
                    "name": "Mark Text to Remove",
                    "text": "Use the editor to mark the text area you want to erase. This helps AI focus on the exact watermark, caption, or logo."
                },
                "step3": {
                    "name": "Erase & Rebuild",
                    "text": "Click 'Create'. AI removes the text from the image and rebuilds the background for a clean final result."
                }
            }
        }
    },
    "zh": {
        "removeTextFromImage": {
            "title": "免费 AI 图片去文字 - 去水印工具 | WeryAI",
            "description": "快速去除图片中的文字、水印、日期水印与 Logo。AI 会智能修补背景，让画面保持干净自然，适合商品修图、社交素材与旧照片整理。",
            "keywords": "图片去文字, AI 去水印, 去日期水印, 在线去水印, 清理图片, AI 修复, 去除图片 Logo",
            "og_title": "免费 AI 图片去文字 - 去水印工具 | WeryAI",
            "og_description": "快速去除图片中的文字、水印、日期水印与 Logo。AI 会智能修补背景，让画面保持干净自然，适合商品修图、社交素材与旧照片整理。",
            "twitter_title": "免费 AI 图片去文字 - 去水印工具 | WeryAI",
            "twitter_description": "快速去除图片中的文字、水印、日期水印与 Logo。AI 会智能修补背景，让画面保持干净自然，适合商品修图、社交素材与旧照片整理。",
            "page": {
                "title1": "快速去掉图片上的文字、水印与 Logo",
                "title2": "需要去除图片文字、移除水印、删除日期水印，或清理商品图上的 Logo 吗？WeryAI 用 AI 修复技术重建背景，让去文字后的图片保持干净自然，不靠模糊遮挡。",
                "faq": [
                    {
                        "question": "什么是 AI 图片去文字工具？",
                        "answer": "AI 图片去文字工具可以自动识别并移除图片中的文字、水印、Logo、字幕或日期水印，再用 AI 修复技术补全背景，让图片恢复干净自然的状态。"
                    },
                    {
                        "question": "如何不糊图地去掉图片上的文字？",
                        "answer": "使用 WeryAI 的 AI 图片去文字工具。它不会用模糊遮盖，而是用 AI 修复（Inpainting）分析周围内容并生成新像素来无缝补背景。"
                    },
                    {
                        "question": "可以去除水印和 Logo 吗？",
                        "answer": "可以。无论是商品图上的 Logo、社交截图里的用户名，还是图片上的水印、宣传字样，AI 都可以帮助你去除并尽量保留原有画面。"
                    },
                    {
                        "question": "可以去掉照片上的日期水印吗？",
                        "answer": "可以。日期水印和时间水印正是最常见的使用场景之一。AI 能识别数字区域，并在去除后还原天空、草地、皮肤或墙面等背景细节。"
                    },
                    {
                        "question": "WeryAI AI 图片去文字工具可以免费使用吗？",
                        "answer": "可以。新用户注册即可获得免费积分，无需信用卡。你还可以通过每日签到、完成任务和邀请好友获取更多免费积分，因此可以在无需预付费的情况下持续使用该工具。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "什么是 AI 图片去文字工具？",
                    "answer": "AI 图片去文字工具可以自动识别并移除图片中的文字、水印、Logo、字幕或日期水印，再用 AI 修复技术补全背景。"
                },
                {
                    "question": "如何不糊图地去掉图片上的文字？",
                    "answer": "它不会用模糊遮盖，而是用 AI 修复（Inpainting）分析周围内容并生成新像素来无缝补背景。"
                },
                {
                    "question": "可以去除水印和 Logo 吗？",
                    "answer": "可以。AI 可以帮助你去除水印、Logo、字幕和其他文字覆盖物，同时尽量保留原有画面。"
                }
            ],
            "feature_title1": "一键去水印与 Logo",
            "feature_desc1": "从商品图、截图、海报或社交素材中去除水印、Logo 与文字覆盖层，不破坏原图画质，更适合做电商图和营销素材清理。",
            "feature_title2": "删除日期水印与字幕",
            "feature_desc2": "旅行照、旧照片、聊天截图或视频封面上的日期水印、时间水印、字幕和用户名，都可以用 AI 快速去除并还原背景。",
            "feature_title3": "AI 修复背景，不靠模糊遮挡",
            "feature_desc3": "WeryAI 不只是把文字抹成一团模糊，而是通过 AI 修复技术重建被挡住的天空、墙面、衣物、草地等背景纹理，让图片更自然。",
            "howto": {
                "name": "如何在线移除图片中的文字",
                "step1": {
                    "name": "上传图片",
                    "text": "上传一张含有文字、水印、日期水印或 Logo 的图片。"
                },
                "step2": {
                    "name": "标记要去除的区域",
                    "text": "在编辑器中标记你想移除的文字区域，让 AI 更准确地处理水印、字幕或 Logo。"
                },
                "step3": {
                    "name": "去文字并修补背景",
                    "text": "点击“创建”，AI 会移除图片中的文字内容，并自动修补背景，输出干净自然的成品图。"
                }
            }
        }
    },
    "ja": {
        "removeTextFromImage": {
            "title": "無料 AI 画像文字削除ツール | WeryAI",
            "description": "画像内の文字、透かし、日付スタンプ、ロゴを AI で自然に削除。背景をなじませながら補完し、商品画像、SNS素材、思い出の写真をきれいに整えます。",
            "keywords": "画像 文字 削除, 透かし 削除, 日付スタンプ 削除, 画像 ロゴ 削除, AI インペインティング, 写真 文字 消す, WeryAI",
            "og_title": "無料 AI 画像文字削除ツール | WeryAI",
            "og_description": "画像内の文字、透かし、日付スタンプ、ロゴを AI で自然に削除。背景をなじませながら補完し、商品画像、SNS素材、思い出の写真をきれいに整えます。",
            "twitter_title": "無料 AI 画像文字削除ツール | WeryAI",
            "twitter_description": "画像内の文字、透かし、日付スタンプ、ロゴを AI で自然に削除。背景をなじませながら補完し、商品画像、SNS素材、思い出の写真をきれいに整えます。",
            "page": {
                "title1": "画像の文字・透かし・ロゴをすばやく削除",
                "title2": "画像の文字を消したい、透かしを削除したい、日付スタンプを消したい。そんな時は WeryAI の AI インペインティングが背景を自然に補完し、ぼかしに頼らずきれいに仕上げます。",
                "faq": [
                    {
                        "question": "AI画像文字削除ツールとは？",
                        "answer": "AI画像文字削除ツールは、画像内の文字、透かし、ロゴ、字幕、日付スタンプを自動で認識して削除し、背景を自然に補完するツールです。"
                    },
                    {
                        "question": "ぼかさずに画像の文字を消すには？",
                        "answer": "WeryAI の AI 画像文字削除ツールを使います。ぼかしで隠すのではなく、周囲の背景を解析して自然に埋め直します。"
                    },
                    {
                        "question": "透かしやロゴも削除できますか？",
                        "answer": "はい。商品画像のロゴ、スクリーンショット上のユーザー名、画像上の透かしや字幕なども削除できます。"
                    },
                    {
                        "question": "写真の日付スタンプは削除できますか？",
                        "answer": "はい。日付スタンプや時刻表示は代表的な用途です。数字部分を認識し、空や草地、壁などの背景を補完しながら削除します。"
                    },
                    {
                        "question": "WeryAI の AI 画像文字削除ツールは無料で使えますか？",
                        "answer": "はい。新規ユーザーは登録時に無料クレジットを受け取れ、クレジットカードも不要です。さらに、毎日のチェックイン、タスク完了、友達招待でも無料クレジットを獲得できます。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "AI画像文字削除ツールとは？",
                    "answer": "画像内の文字、透かし、ロゴ、字幕、日付スタンプを削除し、背景を自然に補完する AI ツールです。"
                },
                {
                    "question": "ぼかさずに画像の文字を消すには？",
                    "answer": "AI が周囲の背景を解析して補完するため、ぼかしに頼らず自然に文字を削除できます。"
                },
                {
                    "question": "透かしやロゴも削除できますか？",
                    "answer": "はい。透かし、ロゴ、字幕、その他の文字オーバーレイを削除できます。"
                }
            ],
            "feature_title1": "透かし・ロゴをワンクリックで削除",
            "feature_desc1": "商品画像、スクリーンショット、販促素材に入った透かしやロゴをすばやく除去し、きれいな画像に整えます。",
            "feature_title2": "日付スタンプ・字幕を整理",
            "feature_desc2": "旅行写真、古い家族写真、チャット画面、動画サムネイルなどに入った日付スタンプや字幕の削除に適しています。",
            "feature_title3": "AI が背景を自然に補完",
            "feature_desc3": "WeryAI は単にぼかすのではなく、空、壁、布地、草地などの背景テクスチャを AI で描き直して自然な仕上がりにします。",
            "howto": {
                "name": "画像から文字をオンラインで削除する方法",
                "step1": {
                    "name": "画像をアップロード",
                    "text": "文字、透かし、日付スタンプ、ロゴのある画像をアップロードします。"
                },
                "step2": {
                    "name": "削除したい範囲を指定",
                    "text": "エディタで削除したい文字エリアをマークすると、AI がより正確に処理できます。"
                },
                "step3": {
                    "name": "文字を削除して背景を補完",
                    "text": "「作成」をクリックすると、AI が文字を削除し、背景を自然に補完します。"
                }
            }
        }
    },
    "ko": {
        "removeTextFromImage": {
            "title": "무료 AI 이미지 글자 제거 도구 | WeryAI",
            "description": "이미지 속 글자, 워터마크, 날짜 스탬프, 로고를 AI로 자연스럽게 제거하세요. 배경까지 깔끔하게 복원해 상품 이미지, SNS 소재, 추억 사진 정리에 잘 맞습니다.",
            "keywords": "이미지 글자 제거, 워터마크 제거, 날짜 스탬프 제거, 이미지 로고 제거, AI 인페인팅, 사진 글자 지우기, WeryAI",
            "og_title": "무료 AI 이미지 글자 제거 도구 | WeryAI",
            "og_description": "이미지 속 글자, 워터마크, 날짜 스탬프, 로고를 AI로 자연스럽게 제거하세요. 배경까지 깔끔하게 복원해 상품 이미지, SNS 소재, 추억 사진 정리에 잘 맞습니다.",
            "twitter_title": "무료 AI 이미지 글자 제거 도구 | WeryAI",
            "twitter_description": "이미지 속 글자, 워터마크, 날짜 스탬프, 로고를 AI로 자연스럽게 제거하세요. 배경까지 깔끔하게 복원해 상품 이미지, SNS 소재, 추억 사진 정리에 잘 맞습니다.",
            "page": {
                "title1": "이미지의 글자, 워터마크, 로고를 빠르게 제거",
                "title2": "이미지 글자를 지우고 싶거나 워터마크, 날짜 스탬프, 로고를 없애고 싶다면 WeryAI를 사용하세요. AI 인페인팅이 배경을 자연스럽게 복원해 흐릿한 흔적 없이 정리해 줍니다.",
                "faq": [
                    {
                        "question": "AI 이미지 글자 제거 도구란 무엇인가요?",
                        "answer": "AI 이미지 글자 제거 도구는 이미지 안의 글자, 워터마크, 로고, 자막, 날짜 스탬프를 자동으로 인식해 제거하고 배경을 자연스럽게 복원하는 도구입니다."
                    },
                    {
                        "question": "흐리게 만들지 않고 이미지 글자를 지우려면 어떻게 하나요?",
                        "answer": "WeryAI의 AI 이미지 글자 제거 도구를 사용하세요. 블러로 덮는 대신 주변 배경을 분석해 자연스럽게 채워 넣습니다."
                    },
                    {
                        "question": "워터마크와 로고도 제거할 수 있나요?",
                        "answer": "네. 상품 이미지의 로고, 스크린샷 속 사용자명, 워터마크, 자막 같은 텍스트 오버레이를 제거할 수 있습니다."
                    },
                    {
                        "question": "사진의 날짜 스탬프도 지울 수 있나요?",
                        "answer": "네. 날짜 스탬프와 시간 표시 제거는 가장 흔한 사용 사례입니다. 숫자를 인식하고 하늘, 벽, 잔디 같은 배경을 복원하면서 제거합니다."
                    },
                    {
                        "question": "이 도구를 무료로 사용할 수 있나요?",
                        "answer": "네. 신규 사용자는 가입 시 신용카드 없이 무료 크레딧을 받을 수 있습니다. 또한 매일 체크인, 작업 완료, 친구 초대를 통해 무료 크레딧을 더 받을 수 있습니다."
                    }
                ]
            },
            "faq": [
                {
                    "question": "AI 이미지 글자 제거 도구란 무엇인가요?",
                    "answer": "이미지 속 글자, 워터마크, 로고, 자막, 날짜 스탬프를 제거하고 배경을 자연스럽게 복원하는 AI 도구입니다."
                },
                {
                    "question": "흐리게 만들지 않고 이미지 글자를 지우려면 어떻게 하나요?",
                    "answer": "AI가 주변 배경을 분석해 채워 넣기 때문에 블러 없이 자연스럽게 글자를 제거할 수 있습니다."
                },
                {
                    "question": "워터마크와 로고도 제거할 수 있나요?",
                    "answer": "네. 워터마크, 로고, 자막 및 기타 텍스트 오버레이를 제거할 수 있습니다."
                }
            ],
            "feature_title1": "워터마크와 로고를 한 번에 제거",
            "feature_desc1": "상품 이미지, 스크린샷, 홍보 소재의 워터마크와 로고를 빠르게 지워 깔끔한 결과물을 만듭니다.",
            "feature_title2": "날짜 스탬프와 자막 정리",
            "feature_desc2": "여행 사진, 오래된 가족 사진, 채팅 캡처, 영상 썸네일의 날짜 스탬프와 자막을 지우는 데 적합합니다.",
            "feature_title3": "AI가 배경을 자연스럽게 복원",
            "feature_desc3": "WeryAI는 단순히 흐리게 처리하지 않고, 하늘, 벽, 옷감, 잔디 같은 배경 질감을 AI로 복원해 자연스럽게 마무리합니다.",
            "howto": {
                "name": "이미지에서 글자를 온라인으로 제거하는 방법",
                "step1": {
                    "name": "이미지 업로드",
                    "text": "글자, 워터마크, 날짜 스탬프, 로고가 포함된 이미지를 업로드하세요."
                },
                "step2": {
                    "name": "지울 영역 표시",
                    "text": "에디터에서 지울 텍스트 영역을 표시하면 AI가 더 정확하게 처리합니다."
                },
                "step3": {
                    "name": "글자 제거 및 배경 복원",
                    "text": "만들기를 클릭하면 AI가 글자를 제거하고 배경을 자연스럽게 복원합니다."
                }
            }
        }
    },
    "es": {
        "removeTextFromImage": {
            "title": "Borrador de Texto en Imágenes con IA Gratis | WeryAI",
            "description": "Elimina texto, marcas de agua, sellos de fecha y logos de imágenes con IA. WeryAI reconstruye el fondo de forma natural para limpiar fotos, capturas, imágenes de producto y materiales sociales.",
            "keywords": "quitar texto de imagen, borrar marca de agua, quitar sello de fecha, quitar logo de imagen, IA inpainting, limpiar fotos, WeryAI",
            "og_title": "Borrador de Texto en Imágenes con IA Gratis | WeryAI",
            "og_description": "Elimina texto, marcas de agua, sellos de fecha y logos de imágenes con IA. WeryAI reconstruye el fondo de forma natural para limpiar fotos, capturas, imágenes de producto y materiales sociales.",
            "twitter_title": "Borrador de Texto en Imágenes con IA Gratis | WeryAI",
            "twitter_description": "Elimina texto, marcas de agua, sellos de fecha y logos de imágenes con IA. WeryAI reconstruye el fondo de forma natural para limpiar fotos, capturas, imágenes de producto y materiales sociales.",
            "page": {
                "title1": "Quita texto, marcas de agua y logos de tus imágenes",
                "title2": "¿Necesitas quitar texto de una imagen, borrar una marca de agua o eliminar un sello de fecha? WeryAI usa IA inpainting para reconstruir el fondo y dejar un resultado limpio, sin manchas ni desenfoque.",
                "faq": [
                    {
                        "question": "¿Qué es un borrador de texto con IA?",
                        "answer": "Es una herramienta que detecta y elimina texto, marcas de agua, logos, subtítulos y sellos de fecha en imágenes mientras reconstruye el fondo con IA."
                    },
                    {
                        "question": "¿Cómo quito texto de una imagen sin que se vea borroso?",
                        "answer": "Usa el Borrador de Texto con IA de WeryAI. En lugar de cubrir el texto con blur, la IA analiza el entorno y rellena el área eliminada de forma natural."
                    },
                    {
                        "question": "¿Puedo eliminar marcas de agua y logos?",
                        "answer": "Sí. Puedes quitar logos de producto, nombres de usuario en capturas, marcas de agua, subtítulos y otros textos superpuestos."
                    },
                    {
                        "question": "¿Puedo quitar sellos de fecha de fotos?",
                        "answer": "Sí. Los sellos de fecha y hora son uno de los casos más comunes. La IA identifica los números y restaura el cielo, la pared, la piel o el césped del fondo."
                    },
                    {
                        "question": "¿Puedo usar gratis el borrador de texto con IA de WeryAI?",
                        "answer": "Sí. Los nuevos usuarios reciben créditos gratis al registrarse sin necesidad de tarjeta. También puedes conseguir más créditos con el check-in diario, completando tareas e invitando amigos."
                    }
                ]
            },
            "faq": [
                {
                    "question": "¿Qué es un borrador de texto con IA?",
                    "answer": "Es una herramienta para eliminar texto, marcas de agua, logos, subtítulos y sellos de fecha mientras reconstruye el fondo con IA."
                },
                {
                    "question": "¿Cómo quito texto de una imagen sin que se vea borroso?",
                    "answer": "La IA analiza el fondo y rellena el área eliminada de forma natural, sin depender de desenfoque."
                },
                {
                    "question": "¿Puedo eliminar marcas de agua y logos?",
                    "answer": "Sí. Puedes eliminar marcas de agua, logos, subtítulos y otros textos superpuestos."
                }
            ],
            "feature_title1": "Borra marcas de agua y logos en un clic",
            "feature_desc1": "Limpia marcas de agua, logos y capas de texto en fotos de producto, capturas y creatividades promocionales sin dañar la imagen original.",
            "feature_title2": "Elimina sellos de fecha y subtítulos",
            "feature_desc2": "Quita sellos de fecha, horas, subtítulos y nombres de usuario de fotos de viaje, imágenes antiguas, capturas de chat y miniaturas.",
            "feature_title3": "La IA reconstruye el fondo",
            "feature_desc3": "WeryAI no solo difumina. La IA vuelve a crear cielo, pared, tela, hierba y otras texturas para que la imagen final se vea limpia y natural.",
            "howto": {
                "name": "Cómo quitar texto de una imagen online",
                "step1": {
                    "name": "Sube la imagen",
                    "text": "Sube una imagen que contenga texto, marca de agua, sello de fecha o logo."
                },
                "step2": {
                    "name": "Marca el área a eliminar",
                    "text": "Marca en el editor la zona de texto que quieres borrar para que la IA trabaje con mayor precisión."
                },
                "step3": {
                    "name": "Borra el texto y reconstruye el fondo",
                    "text": "Haz clic en Crear. La IA elimina el texto y rellena el fondo para dejar una imagen limpia."
                }
            }
        }
    },
    "fr": {
        "removeTextFromImage": {
            "title": "Effaceur de Texte d'Image IA Gratuit | WeryAI",
            "description": "Supprimez texte, filigranes, dates et logos des images avec l’IA. WeryAI reconstruit l’arrière-plan de façon naturelle pour nettoyer photos, captures, visuels produit et contenus sociaux.",
            "keywords": "supprimer texte image, supprimer filigrane image, enlever date photo, enlever logo image, IA inpainting, nettoyer photo, WeryAI",
            "og_title": "Effaceur de Texte d'Image IA Gratuit | WeryAI",
            "og_description": "Supprimez texte, filigranes, dates et logos des images avec l’IA. WeryAI reconstruit l’arrière-plan de façon naturelle pour nettoyer photos, captures, visuels produit et contenus sociaux.",
            "twitter_title": "Effaceur de Texte d'Image IA Gratuit | WeryAI",
            "twitter_description": "Supprimez texte, filigranes, dates et logos des images avec l’IA. WeryAI reconstruit l’arrière-plan de façon naturelle pour nettoyer photos, captures, visuels produit et contenus sociaux.",
            "page": {
                "title1": "Supprimez texte, filigranes et logos de vos images",
                "title2": "Besoin de supprimer du texte d’une image, d’enlever un filigrane ou d’effacer une date ? WeryAI utilise l’IA inpainting pour reconstruire l’arrière-plan et garder un rendu net, sans zones floues.",
                "faq": [
                    {
                        "question": "Qu’est-ce qu’un effaceur de texte IA ?",
                        "answer": "C’est un outil qui détecte et supprime texte, filigranes, logos, sous-titres et dates dans une image, puis reconstruit l’arrière-plan grâce à l’IA."
                    },
                    {
                        "question": "Comment supprimer du texte d’une image sans la flouter ?",
                        "answer": "Utilisez l’effaceur de texte IA de WeryAI. Au lieu de masquer le texte avec du flou, l’IA analyse l’environnement et reconstitue la zone supprimée naturellement."
                    },
                    {
                        "question": "Puis-je enlever des filigranes et des logos ?",
                        "answer": "Oui. Vous pouvez supprimer logos produit, noms d’utilisateur dans les captures, filigranes, sous-titres et autres textes superposés."
                    },
                    {
                        "question": "Puis-je supprimer une date sur une photo ?",
                        "answer": "Oui. Les dates et heures incrustées font partie des cas d’usage les plus fréquents. L’IA détecte les chiffres et restaure le ciel, le mur, la peau ou l’herbe derrière."
                    },
                    {
                        "question": "Puis-je utiliser gratuitement l’effaceur de texte IA WeryAI ?",
                        "answer": "Oui. Les nouveaux utilisateurs reçoivent des crédits gratuits à l’inscription, sans carte bancaire. Vous pouvez aussi obtenir plus de crédits gratuits grâce à la connexion quotidienne, aux tâches terminées et aux invitations d’amis."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Qu’est-ce qu’un effaceur de texte IA ?",
                    "answer": "C’est un outil pour supprimer texte, filigranes, logos, sous-titres et dates d’une image tout en reconstruisant l’arrière-plan avec l’IA."
                },
                {
                    "question": "Comment supprimer du texte d’une image sans la flouter ?",
                    "answer": "L’IA analyse le fond et remplit naturellement la zone supprimée, au lieu de dépendre du flou."
                },
                {
                    "question": "Puis-je enlever des filigranes et des logos ?",
                    "answer": "Oui. Vous pouvez supprimer filigranes, logos, sous-titres et autres superpositions de texte."
                }
            ],
            "feature_title1": "Supprimez filigranes et logos en un clic",
            "feature_desc1": "Nettoyez filigranes, logos et textes superposés sur des visuels produit, captures ou créations marketing sans abîmer l’image d’origine.",
            "feature_title2": "Effacez dates et sous-titres",
            "feature_desc2": "Retirez dates, heures, sous-titres et noms d’utilisateur sur photos de voyage, images anciennes, captures de chat ou miniatures vidéo.",
            "feature_title3": "L’IA reconstruit le fond",
            "feature_desc3": "WeryAI ne se contente pas de flouter. L’IA recrée ciel, mur, tissu, herbe et autres textures pour un résultat propre et naturel.",
            "howto": {
                "name": "Comment supprimer du texte d’une image en ligne",
                "step1": {
                    "name": "Importer une image",
                    "text": "Importez une image contenant du texte, un filigrane, une date ou un logo."
                },
                "step2": {
                    "name": "Marquer la zone à supprimer",
                    "text": "Dans l’éditeur, marquez la zone de texte à effacer pour aider l’IA à être plus précise."
                },
                "step3": {
                    "name": "Supprimer le texte et reconstruire le fond",
                    "text": "Cliquez sur Créer. L’IA supprime le texte et reconstitue l’arrière-plan pour un résultat propre."
                }
            }
        }
    },
    "de": {
        "removeTextFromImage": {
            "title": "KI-Textentferner für Bilder kostenlos | WeryAI",
            "description": "Entfernen Sie Text, Wasserzeichen, Datumsstempel und Logos aus Bildern mit KI. WeryAI rekonstruiert den Hintergrund natürlich und eignet sich für Produktbilder, Screenshots und Social-Media-Grafiken.",
            "keywords": "text aus bild entfernen, wasserzeichen entfernen bild, datumsstempel entfernen, logo aus bild entfernen, KI inpainting, foto bereinigen, WeryAI",
            "og_title": "KI-Textentferner für Bilder kostenlos | WeryAI",
            "og_description": "Entfernen Sie Text, Wasserzeichen, Datumsstempel und Logos aus Bildern mit KI. WeryAI rekonstruiert den Hintergrund natürlich und eignet sich für Produktbilder, Screenshots und Social-Media-Grafiken.",
            "twitter_title": "KI-Textentferner für Bilder kostenlos | WeryAI",
            "twitter_description": "Entfernen Sie Text, Wasserzeichen, Datumsstempel und Logos aus Bildern mit KI. WeryAI rekonstruiert den Hintergrund natürlich und eignet sich für Produktbilder, Screenshots und Social-Media-Grafiken.",
            "page": {
                "title1": "Text, Wasserzeichen und Logos aus Bildern entfernen",
                "title2": "Möchten Sie Text aus einem Bild entfernen, ein Wasserzeichen löschen oder einen Datumsstempel beseitigen? WeryAI nutzt KI-Inpainting, um den Hintergrund natürlich wiederherzustellen – ohne unscharfe Flecken.",
                "faq": [
                    {
                        "question": "Was ist ein KI-Textentferner für Bilder?",
                        "answer": "Ein KI-Textentferner erkennt und entfernt Text, Wasserzeichen, Logos, Untertitel und Datumsstempel aus Bildern und ergänzt den Hintergrund automatisch."
                    },
                    {
                        "question": "Wie entferne ich Text ohne Unschärfe?",
                        "answer": "Mit WeryAI wird Text nicht einfach weichgezeichnet. Die KI analysiert die Umgebung und füllt den entfernten Bereich natürlich wieder auf."
                    },
                    {
                        "question": "Kann ich Wasserzeichen und Logos entfernen?",
                        "answer": "Ja. Sie können Produktlogos, Benutzernamen in Screenshots, Wasserzeichen, Untertitel und andere Text-Overlays entfernen."
                    },
                    {
                        "question": "Kann ich Datumsstempel aus Fotos entfernen?",
                        "answer": "Ja. Datums- und Zeitstempel sind ein typischer Anwendungsfall. Die KI erkennt die Zahlen und stellt Himmel, Wand, Haut oder Gras im Hintergrund wieder her."
                    },
                    {
                        "question": "Kann ich den KI-Textentferner von WeryAI kostenlos nutzen?",
                        "answer": "Ja. Neue Nutzer erhalten bei der Registrierung kostenlose Credits, ganz ohne Kreditkarte. Zusätzlich können Sie durch tägliches Einchecken, Aufgaben und Einladungen weitere kostenlose Credits erhalten."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Was ist ein KI-Textentferner für Bilder?",
                    "answer": "Ein Tool, das Text, Wasserzeichen, Logos, Untertitel und Datumsstempel entfernt und den Hintergrund mit KI rekonstruiert."
                },
                {
                    "question": "Wie entferne ich Text ohne Unschärfe?",
                    "answer": "Die KI analysiert den Hintergrund und ergänzt die entfernte Fläche natürlich, statt sie nur unscharf zu machen."
                },
                {
                    "question": "Kann ich Wasserzeichen und Logos entfernen?",
                    "answer": "Ja. Wasserzeichen, Logos, Untertitel und andere Text-Overlays lassen sich entfernen."
                }
            ],
            "feature_title1": "Wasserzeichen und Logos per Klick entfernen",
            "feature_desc1": "Entfernen Sie Wasserzeichen, Logos und Textüberlagerungen aus Produktbildern, Screenshots und Marketinggrafiken, ohne die Bildqualität zu zerstören.",
            "feature_title2": "Datumsstempel und Untertitel löschen",
            "feature_desc2": "Beseitigen Sie Datumsstempel, Uhrzeiten, Untertitel und Benutzernamen auf Reisefotos, alten Bildern, Chat-Screenshots oder Video-Thumbnails.",
            "feature_title3": "KI stellt den Hintergrund wieder her",
            "feature_desc3": "WeryAI verwischt nicht einfach nur. Die KI rekonstruiert Himmel, Wände, Stoffe, Gras und andere Texturen für ein sauberes, natürliches Ergebnis.",
            "howto": {
                "name": "So entfernen Sie Text online aus einem Bild",
                "step1": {
                    "name": "Bild hochladen",
                    "text": "Laden Sie ein Bild hoch, das Text, Wasserzeichen, Datumsstempel oder Logos enthält."
                },
                "step2": {
                    "name": "Zu entfernenden Bereich markieren",
                    "text": "Markieren Sie im Editor den Textbereich, damit die KI gezielt Wasserzeichen, Untertitel oder Logos bearbeiten kann."
                },
                "step3": {
                    "name": "Text entfernen und Hintergrund rekonstruieren",
                    "text": "Klicken Sie auf Erstellen. Die KI entfernt den Text und stellt den Hintergrund sauber wieder her."
                }
            }
        }
    },
    "ru": {
        "removeTextFromImage": {
            "title": "Удаление текста с изображений ИИ | WeryAI",
            "description": "Удаляйте текст, водяные знаки, штампы даты и логотипы с изображений с помощью ИИ. WeryAI естественно восстанавливает фон и подходит для фото товаров, скриншотов и соцсетей.",
            "keywords": "удалить текст с изображения, удалить водяной знак, убрать штамп даты, удалить логотип с фото, AI inpainting, очистить фото, WeryAI",
            "og_title": "Удаление текста с изображений ИИ | WeryAI",
            "og_description": "Удаляйте текст, водяные знаки, штампы даты и логотипы с изображений с помощью ИИ. WeryAI естественно восстанавливает фон и подходит для фото товаров, скриншотов и соцсетей.",
            "twitter_title": "Удаление текста с изображений ИИ | WeryAI",
            "twitter_description": "Удаляйте текст, водяные знаки, штампы даты и логотипы с изображений с помощью ИИ. WeryAI естественно восстанавливает фон и подходит для фото товаров, скриншотов и соцсетей.",
            "page": {
                "title1": "Удаляйте текст, водяные знаки и логотипы с изображений",
                "title2": "Нужно убрать текст с картинки, удалить водяной знак или стереть штамп даты? WeryAI использует AI Inpainting, чтобы естественно восстановить фон без размытия и следов редактирования.",
                "faq": [
                    {
                        "question": "Что такое AI-инструмент для удаления текста?",
                        "answer": "Это инструмент, который распознаёт и удаляет текст, водяные знаки, логотипы, субтитры и штампы даты на изображениях, а затем восстанавливает фон с помощью ИИ."
                    },
                    {
                        "question": "Как удалить текст без размытия?",
                        "answer": "WeryAI не просто замазывает текст блюром. ИИ анализирует окружение и естественно дорисовывает удалённую область."
                    },
                    {
                        "question": "Можно ли убрать водяные знаки и логотипы?",
                        "answer": "Да. Можно удалить логотипы на товарных фото, имена пользователей на скриншотах, водяные знаки, субтитры и другие текстовые наложения."
                    },
                    {
                        "question": "Можно ли убрать дату с фотографии?",
                        "answer": "Да. Дата и время на фото — один из самых частых сценариев. ИИ распознаёт цифры и восстанавливает небо, стену, кожу или траву позади них."
                    },
                    {
                        "question": "Можно ли пользоваться AI-удалением текста WeryAI бесплатно?",
                        "answer": "Да. Новые пользователи получают бесплатные кредиты при регистрации без банковской карты. Дополнительные кредиты можно получать за ежедневные отметки, задания и приглашение друзей."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Что такое AI-инструмент для удаления текста?",
                    "answer": "Это инструмент для удаления текста, водяных знаков, логотипов, субтитров и штампов даты с восстановлением фона с помощью ИИ."
                },
                {
                    "question": "Как удалить текст без размытия?",
                    "answer": "ИИ анализирует фон и естественно заполняет очищенную область вместо простого размытия."
                },
                {
                    "question": "Можно ли убрать водяные знаки и логотипы?",
                    "answer": "Да. Можно удалить водяные знаки, логотипы, субтитры и другие текстовые наложения."
                }
            ],
            "feature_title1": "Удаляйте водяные знаки и логотипы в один клик",
            "feature_desc1": "Очищайте товарные фото, скриншоты и рекламные макеты от водяных знаков, логотипов и текста без потери качества.",
            "feature_title2": "Стирайте дату и субтитры",
            "feature_desc2": "Удаляйте даты, время, субтитры и имена пользователей с фото из путешествий, старых снимков, чатов и видеопревью.",
            "feature_title3": "ИИ восстанавливает фон",
            "feature_desc3": "WeryAI не просто размывает область. ИИ заново создаёт небо, стену, ткань, траву и другие текстуры, чтобы изображение выглядело естественно.",
            "howto": {
                "name": "Как удалить текст с изображения онлайн",
                "step1": {
                    "name": "Загрузите изображение",
                    "text": "Загрузите изображение с текстом, водяным знаком, штампом даты или логотипом."
                },
                "step2": {
                    "name": "Отметьте область для удаления",
                    "text": "Отметьте в редакторе область текста, чтобы ИИ точнее обработал водяной знак, субтитр или логотип."
                },
                "step3": {
                    "name": "Удалите текст и восстановите фон",
                    "text": "Нажмите «Создать». ИИ удалит текст и естественно восстановит фон."
                }
            }
        }
    },
    "pt": {
        "removeTextFromImage": {
            "title": "Remover Texto de Imagens com IA | WeryAI",
            "description": "Remova texto, marcas d’água, carimbos de data e logos de imagens com IA. O WeryAI reconstrói o fundo de forma natural para limpar fotos, capturas e criativos de produto.",
            "keywords": "remover texto da imagem, remover marca d’água, remover data da foto, remover logo da imagem, IA inpainting, limpar foto, WeryAI",
            "og_title": "Remover Texto de Imagens com IA | WeryAI",
            "og_description": "Remova texto, marcas d’água, carimbos de data e logos de imagens com IA. O WeryAI reconstrói o fundo de forma natural para limpar fotos, capturas e criativos de produto.",
            "twitter_title": "Remover Texto de Imagens com IA | WeryAI",
            "twitter_description": "Remova texto, marcas d’água, carimbos de data e logos de imagens com IA. O WeryAI reconstrói o fundo de forma natural para limpar fotos, capturas e criativos de produto.",
            "page": {
                "title1": "Remova texto, marcas d’água e logos das imagens",
                "title2": "Quer remover texto de uma imagem, apagar uma marca d’água ou eliminar um carimbo de data? O WeryAI usa IA inpainting para reconstruir o fundo de forma natural, sem manchas nem borrões.",
                "faq": [
                    {
                        "question": "O que é um removedor de texto com IA?",
                        "answer": "É uma ferramenta que detecta e remove texto, marcas d’água, logos, legendas e carimbos de data em imagens, reconstruindo o fundo com IA."
                    },
                    {
                        "question": "Como remover texto de uma imagem sem borrar?",
                        "answer": "Use o removedor de texto com IA da WeryAI. Em vez de cobrir o texto com blur, a IA analisa o entorno e recompõe a área removida naturalmente."
                    },
                    {
                        "question": "Posso remover marcas d’água e logos?",
                        "answer": "Sim. Você pode remover logos de produtos, nomes de usuário em capturas, marcas d’água, legendas e outros textos sobrepostos."
                    },
                    {
                        "question": "Posso remover carimbos de data de fotos?",
                        "answer": "Sim. Carimbos de data e hora são um dos usos mais comuns. A IA identifica os números e restaura céu, parede, pele ou grama atrás deles."
                    },
                    {
                        "question": "Posso usar o removedor de texto com IA da WeryAI de graça?",
                        "answer": "Sim. Novos usuários recebem créditos grátis ao se cadastrar, sem precisar de cartão. Você também pode ganhar mais créditos com check-in diário, tarefas concluídas e convites de amigos."
                    }
                ]
            },
            "faq": [
                {
                    "question": "O que é um removedor de texto com IA?",
                    "answer": "É uma ferramenta para remover texto, marcas d’água, logos, legendas e carimbos de data enquanto reconstrói o fundo com IA."
                },
                {
                    "question": "Como remover texto de uma imagem sem borrar?",
                    "answer": "A IA analisa o fundo e preenche a área removida naturalmente, sem depender de borrão."
                },
                {
                    "question": "Posso remover marcas d’água e logos?",
                    "answer": "Sim. Você pode remover marcas d’água, logos, legendas e outros textos sobrepostos."
                }
            ],
            "feature_title1": "Remova marcas d’água e logos com um clique",
            "feature_desc1": "Limpe marcas d’água, logos e sobreposições de texto em fotos de produto, capturas e criativos de marketing sem prejudicar a qualidade original.",
            "feature_title2": "Apague datas e legendas",
            "feature_desc2": "Remova datas, horários, legendas e nomes de usuário de fotos de viagem, imagens antigas, capturas de chat e thumbnails de vídeo.",
            "feature_title3": "A IA reconstrói o fundo",
            "feature_desc3": "WeryAI não apenas desfoca a área. A IA recria céu, parede, tecido, grama e outras texturas para deixar a imagem final limpa e natural.",
            "howto": {
                "name": "Como remover texto de uma imagem online",
                "step1": {
                    "name": "Envie a imagem",
                    "text": "Envie uma imagem que contenha texto, marca d’água, carimbo de data ou logo."
                },
                "step2": {
                    "name": "Marque a área para remover",
                    "text": "Marque no editor a área de texto que deseja apagar para a IA agir com mais precisão."
                },
                "step3": {
                    "name": "Apague o texto e reconstrua o fundo",
                    "text": "Clique em Criar. A IA remove o texto e reconstrói o fundo para entregar uma imagem limpa."
                }
            }
        }
    },
    "it": {
        "removeTextFromImage": {
            "title": "Rimuovere Testo dalle Immagini con IA | WeryAI",
            "description": "Rimuovi testo, filigrane, timbri data e loghi dalle immagini con l’IA. WeryAI ricostruisce lo sfondo in modo naturale per ripulire foto, screenshot e creatività di prodotto.",
            "keywords": "rimuovere testo immagine, rimuovere filigrana, eliminare data foto, rimuovere logo immagine, IA inpainting, pulire foto, WeryAI",
            "og_title": "Rimuovere Testo dalle Immagini con IA | WeryAI",
            "og_description": "Rimuovi testo, filigrane, timbri data e loghi dalle immagini con l’IA. WeryAI ricostruisce lo sfondo in modo naturale per ripulire foto, screenshot e creatività di prodotto.",
            "twitter_title": "Rimuovere Testo dalle Immagini con IA | WeryAI",
            "twitter_description": "Rimuovi testo, filigrane, timbri data e loghi dalle immagini con l’IA. WeryAI ricostruisce lo sfondo in modo naturale per ripulire foto, screenshot e creatività di prodotto.",
            "page": {
                "title1": "Rimuovi testo, filigrane e loghi dalle immagini",
                "title2": "Vuoi rimuovere testo da un’immagine, cancellare una filigrana o eliminare un timbro data? WeryAI usa l’AI inpainting per ricostruire lo sfondo in modo naturale, senza macchie o sfocature.",
                "faq": [
                    {
                        "question": "Che cos’è uno strumento IA per rimuovere testo?",
                        "answer": "È uno strumento che rileva e rimuove testo, filigrane, loghi, sottotitoli e timbri data nelle immagini, ricostruendo lo sfondo con l’IA."
                    },
                    {
                        "question": "Come rimuovere testo da un’immagine senza sfocarla?",
                        "answer": "Usa lo strumento IA di WeryAI. Invece di coprire il testo con sfocature, l’IA analizza l’area circostante e ricrea lo sfondo in modo naturale."
                    },
                    {
                        "question": "Posso rimuovere filigrane e loghi?",
                        "answer": "Sì. Puoi rimuovere loghi di prodotto, nomi utente negli screenshot, filigrane, sottotitoli e altri testi sovrapposti."
                    },
                    {
                        "question": "Posso eliminare i timbri data dalle foto?",
                        "answer": "Sì. Data e ora sulle foto sono tra gli usi più comuni. L’IA riconosce i numeri e ripristina cielo, muro, pelle o erba dietro di essi."
                    },
                    {
                        "question": "Posso usare gratis lo strumento IA di WeryAI?",
                        "answer": "Sì. I nuovi utenti ricevono crediti gratuiti al momento della registrazione senza carta di credito. Inoltre puoi ottenere altri crediti gratuiti con check-in giornaliero, attività completate e inviti agli amici."
                    }
                ]
            },
            "faq": [
                {
                    "question": "Che cos’è uno strumento IA per rimuovere testo?",
                    "answer": "È uno strumento per eliminare testo, filigrane, loghi, sottotitoli e timbri data ricostruendo lo sfondo con l’IA."
                },
                {
                    "question": "Come rimuovere testo da un’immagine senza sfocarla?",
                    "answer": "L’IA analizza lo sfondo e riempie naturalmente l’area ripulita, senza affidarsi alla sfocatura."
                },
                {
                    "question": "Posso rimuovere filigrane e loghi?",
                    "answer": "Sì. Puoi rimuovere filigrane, loghi, sottotitoli e altri testi sovrapposti."
                }
            ],
            "feature_title1": "Rimuovi filigrane e loghi con un clic",
            "feature_desc1": "Ripulisci filigrane, loghi e testi sovrapposti da immagini di prodotto, screenshot e grafiche marketing senza danneggiare la qualità originale.",
            "feature_title2": "Elimina timbri data e sottotitoli",
            "feature_desc2": "Rimuovi date, orari, sottotitoli e nomi utente da foto di viaggio, immagini vecchie, chat e miniature video.",
            "feature_title3": "L’IA ricostruisce lo sfondo",
            "feature_desc3": "WeryAI non si limita a sfocare. L’IA ricrea cielo, pareti, tessuti, erba e altre texture per un risultato pulito e naturale.",
            "howto": {
                "name": "Come rimuovere testo da un’immagine online",
                "step1": {
                    "name": "Carica l’immagine",
                    "text": "Carica un’immagine che contiene testo, filigrana, timbro data o logo."
                },
                "step2": {
                    "name": "Segna l’area da rimuovere",
                    "text": "Segna nell’editor l’area di testo da cancellare per aiutare l’IA a lavorare con più precisione."
                },
                "step3": {
                    "name": "Rimuovi il testo e ricostruisci lo sfondo",
                    "text": "Fai clic su Crea. L’IA rimuove il testo e ricostruisce lo sfondo per un risultato pulito."
                }
            }
        }
    },
    "ar": {
        "removeTextFromImage": {
            "title": "إزالة النص من الصور بالذكاء الاصطناعي | WeryAI",
            "description": "أزل النصوص والعلامات المائية وتواريخ الصور والشعارات من الصور باستخدام الذكاء الاصطناعي. يعيد WeryAI بناء الخلفية بشكل طبيعي لتنظيف الصور واللقطات ومواد المنتجات.",
            "keywords": "إزالة النص من الصورة, إزالة العلامة المائية, إزالة التاريخ من الصورة, إزالة الشعار من الصورة, AI inpainting, تنظيف الصور, WeryAI",
            "og_title": "إزالة النص من الصور بالذكاء الاصطناعي | WeryAI",
            "og_description": "أزل النصوص والعلامات المائية وتواريخ الصور والشعارات من الصور باستخدام الذكاء الاصطناعي. يعيد WeryAI بناء الخلفية بشكل طبيعي لتنظيف الصور واللقطات ومواد المنتجات.",
            "twitter_title": "إزالة النص من الصور بالذكاء الاصطناعي | WeryAI",
            "twitter_description": "أزل النصوص والعلامات المائية وتواريخ الصور والشعارات من الصور باستخدام الذكاء الاصطناعي. يعيد WeryAI بناء الخلفية بشكل طبيعي لتنظيف الصور واللقطات ومواد المنتجات.",
            "page": {
                "title1": "أزل النصوص والعلامات المائية والشعارات من الصور",
                "title2": "هل تريد إزالة النص من صورة، أو حذف علامة مائية، أو مسح تاريخ الصورة؟ يستخدم WeryAI تقنية AI inpainting لإعادة بناء الخلفية بشكل طبيعي ومن دون ضبابية أو آثار تعديل واضحة.",
                "faq": [
                    {
                        "question": "ما هي أداة إزالة النصوص بالذكاء الاصطناعي؟",
                        "answer": "هي أداة تكتشف النصوص والعلامات المائية والشعارات والترجمات وتواريخ الصور داخل الصورة، ثم تزيلها وتعيد بناء الخلفية بالذكاء الاصطناعي."
                    },
                    {
                        "question": "كيف أزيل النص من صورة من دون ضبابية؟",
                        "answer": "استخدم أداة WeryAI لإزالة النصوص. بدلاً من تغطية النص بالطمس، يحلل الذكاء الاصطناعي المنطقة المحيطة ويعيد بناء الخلفية بشكل طبيعي."
                    },
                    {
                        "question": "هل يمكنني إزالة العلامات المائية والشعارات؟",
                        "answer": "نعم. يمكنك إزالة شعارات المنتجات، أسماء المستخدمين في لقطات الشاشة، العلامات المائية، الترجمات، وأي نصوص متراكبة أخرى."
                    },
                    {
                        "question": "هل يمكنني إزالة تاريخ الصورة؟",
                        "answer": "نعم. تاريخ الصورة ووقت الالتقاط من أكثر الاستخدامات شيوعاً. يتعرف الذكاء الاصطناعي على الأرقام ويعيد بناء السماء أو الجدار أو البشرة أو العشب خلفها."
                    },
                    {
                        "question": "هل يمكنني استخدام أداة إزالة النصوص من WeryAI مجاناً؟",
                        "answer": "نعم. يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل من دون بطاقة ائتمان، ويمكنك أيضاً الحصول على مزيد من الأرصدة عبر تسجيل الدخول اليومي وإكمال المهام ودعوة الأصدقاء."
                    }
                ]
            },
            "faq": [
                {
                    "question": "ما هي أداة إزالة النصوص بالذكاء الاصطناعي؟",
                    "answer": "هي أداة لإزالة النصوص والعلامات المائية والشعارات والترجمات وتواريخ الصور مع إعادة بناء الخلفية بالذكاء الاصطناعي."
                },
                {
                    "question": "كيف أزيل النص من صورة من دون ضبابية؟",
                    "answer": "يحلل الذكاء الاصطناعي الخلفية ويملأ المنطقة المحذوفة بشكل طبيعي بدلاً من الاعتماد على التمويه."
                },
                {
                    "question": "هل يمكنني إزالة العلامات المائية والشعارات؟",
                    "answer": "نعم. يمكنك إزالة العلامات المائية والشعارات والترجمات وأي نصوص متراكبة أخرى."
                }
            ],
            "feature_title1": "أزل العلامات المائية والشعارات بنقرة واحدة",
            "feature_desc1": "نظّف صور المنتجات ولقطات الشاشة والمواد التسويقية من العلامات المائية والشعارات والنصوص المتراكبة من دون الإضرار بجودة الصورة الأصلية.",
            "feature_title2": "احذف التواريخ والترجمات",
            "feature_desc2": "أزل تواريخ الصور والأوقات والترجمات وأسماء المستخدمين من صور السفر والصور القديمة ولقطات الدردشة وصور الفيديو المصغرة.",
            "feature_title3": "الذكاء الاصطناعي يعيد بناء الخلفية",
            "feature_desc3": "WeryAI لا يكتفي بطمس المنطقة. بل يعيد إنشاء السماء والجدران والأقمشة والعشب والملمس المحيط للحصول على نتيجة نظيفة وطبيعية.",
            "howto": {
                "name": "كيفية إزالة النص من صورة عبر الإنترنت",
                "step1": {
                    "name": "ارفع الصورة",
                    "text": "ارفع صورة تحتوي على نص أو علامة مائية أو تاريخ أو شعار."
                },
                "step2": {
                    "name": "حدّد المنطقة المراد حذفها",
                    "text": "حدّد في المحرر منطقة النص التي تريد حذفها ليعالجها الذكاء الاصطناعي بدقة أكبر."
                },
                "step3": {
                    "name": "أزل النص وأعد بناء الخلفية",
                    "text": "انقر على إنشاء. سيزيل الذكاء الاصطناعي النص ويعيد بناء الخلفية للحصول على صورة نظيفة."
                }
            }
        }
    },
    "tw": {
        "removeTextFromImage": {
            "title": "免費 AI 圖片去文字 - 去浮水印工具 | WeryAI",
            "description": "快速移除圖片中的文字、Logo、日期戳記與浮水印。AI 會智慧補背景，讓畫面保持乾淨自然，特別適合商品修圖、社群素材與舊照片整理。",
            "keywords": "圖片去文字, AI 去浮水印, 去日期戳記, 線上去浮水印, 清理圖片, AI 修補, 去除圖片 Logo",
            "og_title": "免費 AI 圖片去文字 - 去浮水印工具 | WeryAI",
            "og_description": "快速移除圖片中的文字、Logo、日期戳記與浮水印。AI 會智慧補背景，讓畫面保持乾淨自然，特別適合商品修圖、社群素材與舊照片整理。",
            "twitter_title": "免費 AI 圖片去文字 - 去浮水印工具 | WeryAI",
            "twitter_description": "快速移除圖片中的文字、Logo、日期戳記與浮水印。AI 會智慧補背景，讓畫面保持乾淨自然，特別適合商品修圖、社群素材與舊照片整理。",
            "page": {
                "title1": "快速去掉圖片上的文字、浮水印與 Logo",
                "title2": "需要去除圖片文字、移除浮水印、刪除日期戳記，或清理商品圖上的 Logo 嗎？WeryAI 用 AI 修補技術重建背景，讓去文字後的圖片保持乾淨自然，不靠模糊遮擋。",
                "faq": [
                    {
                        "question": "什麼是 AI 圖片去文字工具？",
                        "answer": "AI 圖片去文字工具可以自動識別並移除圖片中的文字、浮水印、Logo、字幕或日期戳記，再用 AI 修補技術補全背景，讓圖片恢復乾淨自然。"
                    },
                    {
                        "question": "如何不糊圖地去掉圖片上的文字？",
                        "answer": "使用 WeryAI 的 AI 圖片去文字工具。它不會用模糊遮住文字，而是透過 AI 修補（Inpainting）分析周圍內容並重建背景。"
                    },
                    {
                        "question": "可以去除浮水印和 Logo 嗎？",
                        "answer": "可以。無論是商品圖上的 Logo、社群截圖裡的帳號名，還是圖片上的浮水印、標語與字幕，AI 都可以協助去除並盡量保留原本畫面。"
                    },
                    {
                        "question": "可以去掉照片上的日期戳記嗎？",
                        "answer": "可以。日期戳記和時間浮水印正是最常見的使用場景之一。AI 能辨識數字區域，並在去除後還原天空、草地、牆面或皮膚等背景細節。"
                    },
                    {
                        "question": "這個工具可以免費使用嗎？",
                        "answer": "可以。新用戶註冊即可獲得免費積分，無需信用卡。你還可以透過每日簽到、完成任務和邀請好友獲得更多免費積分，因此無需預付費也能持續使用圖片去文字工具。"
                    }
                ]
            },
            "faq": [
                {
                    "question": "什麼是 AI 圖片去文字工具？",
                    "answer": "AI 圖片去文字工具可以自動識別並移除圖片中的文字、浮水印、Logo、字幕或日期戳記，再用 AI 修補技術補全背景。"
                },
                {
                    "question": "如何不糊圖地去掉圖片上的文字？",
                    "answer": "它不會用模糊遮住文字，而是透過 AI 修補（Inpainting）分析周圍內容並重建背景。"
                },
                {
                    "question": "可以去除浮水印和 Logo 嗎？",
                    "answer": "可以。AI 可以協助去除浮水印、Logo、字幕與其他文字覆蓋物，同時盡量保留原本畫面。"
                },
                {
                    "question": "可以去掉照片上的日期戳記嗎？",
                    "answer": "可以。日期戳記和時間浮水印正是最常見的使用場景之一，AI 能辨識數字區域並還原背景。"
                },
                {
                    "question": "這個工具可以免費使用嗎？",
                    "answer": "可以。新用戶註冊即可獲得免費積分，無需信用卡。你還可以透過每日簽到、完成任務和邀請好友獲得更多免費積分，因此無需預付費也能持續使用圖片去文字工具。"
                }
            ],
            "feature_title1": "一鍵去浮水印與 Logo",
            "feature_desc1": "從商品圖、截圖、海報或社群素材中去除浮水印、Logo 與文字覆蓋層，不破壞原圖畫質，更適合做電商圖和行銷素材清理。",
            "feature_title2": "刪除日期戳記與字幕",
            "feature_desc2": "旅行照、舊照片、聊天截圖或影片封面上的日期戳記、時間浮水印、字幕和帳號名稱，都可以用 AI 快速去除並還原背景。",
            "feature_title3": "AI 修補背景，不靠模糊遮擋",
            "feature_desc3": "WeryAI 不只是把文字抹成一團模糊，而是透過 AI 修補技術重建被擋住的天空、牆面、衣物、草地等背景紋理，讓圖片更自然。",
            "howto": {
                "name": "如何在線移除圖片中的文字",
                "step1": {
                    "name": "上傳圖片",
                    "text": "上傳一張含有文字、浮水印、日期戳記或 Logo 的圖片。"
                },
                "step2": {
                    "name": "標記要去除的區域",
                    "text": "在編輯器中標記你想移除的文字區域，讓 AI 更準確地處理浮水印、字幕或 Logo。"
                },
                "step3": {
                    "name": "去文字並修補背景",
                    "text": "點擊「建立」，AI 會移除圖片中的文字內容，並自動修補背景，輸出乾淨自然的成品圖。"
                }
            },
            "app_name": "免費 AI 圖片去文字 - 去浮水印工具",
            "app_desc": "快速移除圖片中的文字、Logo、日期戳記與浮水印。AI 會智慧補背景，讓畫面保持乾淨自然，特別適合商品修圖、社群素材與舊照片整理。",
            "feature_title4": "隱私安全",
            "feature_desc4": "你的上傳內容會以安全方式處理，僅用於當前任務，不會被濫用。",
            "textRemoverHowToUseTitle": "如何在線移除圖片中的文字",
            "textRemoverHowToUseDesc": "简單三步，讓你的圖片焕然一新",
            "textRemoverHowToUseStep1Title": "上傳圖片",
            "textRemoverHowToUseStep1Desc": "上傳一張含有文字、浮水印、日期戳記或 Logo 的圖片。",
            "textRemoverHowToUseStep2Title": "標記要去除的區域",
            "textRemoverHowToUseStep2Desc": "在編輯器中標記你想移除的文字區域，讓 AI 更準確地處理浮水印、字幕或 Logo。",
            "textRemoverHowToUseStep3Title": "去文字並修補背景",
            "textRemoverHowToUseStep3Desc": "點擊「建立」，AI 會移除圖片中的文字內容，並自動修補背景，輸出乾淨自然的成品圖。",
            "desc": "如何在線移除圖片中的文字"
        }
    },
    "pl": {
        "removeTextFromImage": {
            "title": "AI Usuwanie Tekstu z Obrazów | WeryAI",
            "description": "Usuwaj tekst, znaki wodne, datowniki i logotypy z obrazów dzięki AI. WeryAI naturalnie odbudowuje tło, więc łatwo wyczyścisz zdjęcia, zrzuty ekranu i grafiki produktowe.",
            "keywords": "usuń tekst z obrazu, usuń znak wodny, usuń datownik, usuń logo ze zdjęcia, AI inpainting, czyszczenie zdjęć, WeryAI",
            "og_title": "AI Usuwanie Tekstu z Obrazów | WeryAI",
            "og_description": "Usuwaj tekst, znaki wodne, datowniki i logotypy z obrazów dzięki AI. WeryAI naturalnie odbudowuje tło, więc łatwo wyczyścisz zdjęcia, zrzuty ekranu i grafiki produktowe.",
            "twitter_title": "AI Usuwanie Tekstu z Obrazów | WeryAI",
            "twitter_description": "Usuwaj tekst, znaki wodne, datowniki i logotypy z obrazów dzięki AI. WeryAI naturalnie odbudowuje tło, więc łatwo wyczyścisz zdjęcia, zrzuty ekranu i grafiki produktowe.",
            "page": {
                "title1": "Usuń tekst, znaki wodne i logo z obrazów",
                "title2": "Chcesz usunąć tekst z obrazu, wyczyścić znak wodny albo skasować datownik? WeryAI używa AI inpaintingu, aby naturalnie odbudować tło bez rozmytych plam i śladów edycji.",
                "faq": [
                    {
                        "question": "Czym jest narzędzie AI do usuwania tekstu?",
                        "answer": "To narzędzie, które wykrywa i usuwa tekst, znaki wodne, logo, napisy i datowniki z obrazów, a następnie odbudowuje tło za pomocą AI."
                    },
                    {
                        "question": "Jak usunąć tekst ze zdjęcia bez rozmycia?",
                        "answer": "Użyj narzędzia WeryAI. Zamiast zamazywać tekst, AI analizuje otoczenie i naturalnie odtwarza usunięty fragment."
                    },
                    {
                        "question": "Czy mogę usuwać znaki wodne i logo?",
                        "answer": "Tak. Możesz usuwać logotypy z zdjęć produktowych, nazwy użytkowników ze zrzutów ekranu, znaki wodne, napisy i inne nakładki tekstowe."
                    },
                    {
                        "question": "Czy mogę usunąć datownik ze zdjęcia?",
                        "answer": "Tak. Datownik i godzina na zdjęciu to bardzo częsty przypadek użycia. AI rozpoznaje cyfry i odtwarza niebo, ścianę, skórę lub trawę w tle."
                    },
                    {
                        "question": "Czy mogę korzystać z AI usuwania tekstu WeryAI za darmo?",
                        "answer": "Tak. Nowi użytkownicy otrzymują darmowe kredyty po rejestracji bez karty kredytowej. Możesz też zdobywać kolejne kredyty dzięki codziennemu check-inowi, zadaniom i zapraszaniu znajomych."
                    }
                ],
                "title3": "Lepsze rezultaty",
                "title4": "Dlaczego warto używać tego narzędzia?",
                "feature_title": "Usuń znaki wodne i logo jednym kliknięciem",
                "click_erase": "Usuwanie jednym kliknięciem",
                "percision_erase": "Usuwanie precyzyjne",
                "video_link_title": "Link do wideo",
                "direct_link_desc": "Wklej bezpośredni link do filmu, aby przetworzyć go online",
                "lossless_qua_title": "Przywracanie bez utraty jakości",
                "dual_input_modes": "Dwa tryby wejścia",
                "audio_sync": "Synchronizacja audio",
                "text_sync": "Tekst na mowę",
                "text_sync_tip": "Wpisz dowolny tekst, wybierz głos AI i pozwól postaci natychmiast go wypowiedzieć.",
                "audio_sync_tip": "Prześlij własny dubbing lub utwór, aby zsynchronizować ruch ust.",
                "feature_title1": "Usuń znaki wodne i logo jednym kliknięciem",
                "feature_desc1": "Czyść znaki wodne, logo i tekst z grafik produktowych, zrzutów ekranu i materiałów marketingowych bez utraty jakości obrazu.",
                "feature_title2": "Usuń datowniki i napisy",
                "feature_desc2": "Kasuj datowniki, godziny, napisy i nazwy użytkowników ze zdjęć z podróży, starych fotografii, czatów i miniaturek wideo.",
                "feature_title3": "AI odbudowuje tło",
                "feature_desc3": "WeryAI nie tylko rozmazuje obszar. AI odtwarza niebo, ściany, tkaniny, trawę i inne tekstury, aby końcowy obraz wyglądał naturalnie.",
                "feature_title4": "Prywatność i bezpieczeństwo",
                "feature_desc4": "Twoje pliki są przetwarzane bezpiecznie i używane wyłącznie do bieżącego zadania."
            },
            "faq": [
                {
                    "question": "Czym jest narzędzie AI do usuwania tekstu?",
                    "answer": "To narzędzie do usuwania tekstu, znaków wodnych, logo, napisów i datowników z jednoczesnym odbudowaniem tła przez AI."
                },
                {
                    "question": "Jak usunąć tekst ze zdjęcia bez rozmycia?",
                    "answer": "AI analizuje tło i naturalnie uzupełnia wyczyszczony obszar zamiast polegać na rozmyciu."
                },
                {
                    "question": "Czy mogę usuwać znaki wodne i logo?",
                    "answer": "Tak. Możesz usuwać znaki wodne, logo, napisy i inne nakładki tekstowe."
                }
            ],
            "feature_title1": "Usuń znaki wodne i logo jednym kliknięciem",
            "feature_desc1": "Czyść znaki wodne, logo i tekst z grafik produktowych, zrzutów ekranu i materiałów marketingowych bez utraty jakości obrazu.",
            "feature_title2": "Usuń datowniki i napisy",
            "feature_desc2": "Kasuj datowniki, godziny, napisy i nazwy użytkowników ze zdjęć z podróży, starych fotografii, czatów i miniaturek wideo.",
            "feature_title3": "AI odbudowuje tło",
            "feature_desc3": "WeryAI nie tylko rozmazuje obszar. AI odtwarza niebo, ściany, tkaniny, trawę i inne tekstury, aby końcowy obraz wyglądał naturalnie.",
            "howto": {
                "name": "Jak usunąć tekst z obrazu online",
                "step1": {
                    "name": "Prześlij obraz",
                    "text": "Prześlij obraz zawierający tekst, znak wodny, datownik lub logo."
                },
                "step2": {
                    "name": "Zaznacz obszar do usunięcia",
                    "text": "Zaznacz w edytorze obszar tekstu, aby AI mogło pracować precyzyjniej."
                },
                "step3": {
                    "name": "Usuń tekst i odbuduj tło",
                    "text": "Kliknij Utwórz. AI usunie tekst i naturalnie odbuduje tło."
                }
            },
            "app_name": "AI Usuwanie Tekstu z Obrazów",
            "app_desc": "Usuwaj tekst, znaki wodne, datowniki i logotypy z obrazów dzięki AI. WeryAI naturalnie odbudowuje tło, więc łatwo wyczyścisz zdjęcia, zrzuty ekranu i grafiki produktowe.",
            "feature_title4": "Prywatność i bezpieczeństwo",
            "feature_desc4": "Twoje pliki są przetwarzane bezpiecznie i używane wyłącznie do bieżącego zadania.",
            "textRemoverHowToUseTitle": "Jak usunąć tekst z obrazu online",
            "textRemoverHowToUseDesc": "Wystarczą 3 proste kroki",
            "textRemoverHowToUseStep1Title": "Prześlij obraz",
            "textRemoverHowToUseStep1Desc": "Prześlij obraz zawierający tekst, znak wodny, datownik lub logo.",
            "textRemoverHowToUseStep2Title": "Zaznacz obszar do usunięcia",
            "textRemoverHowToUseStep2Desc": "Zaznacz w edytorze obszar tekstu, aby AI mogło pracować precyzyjniej.",
            "textRemoverHowToUseStep3Title": "Usuń tekst i odbuduj tło",
            "textRemoverHowToUseStep3Desc": "Kliknij Utwórz. AI usunie tekst i naturalnie odbuduje tło."
        }
    },
    "th": {
        "removeTextFromImage": {
            "title": "ลบข้อความออกจากรูปภาพด้วย AI ฟรี | WeryAI",
            "description": "ลบข้อความ ลายน้ำ วันที่ และโลโก้ออกจากรูปภาพด้วย AI พร้อมซ่อมพื้นหลังให้ดูกลมกลืน เหมาะกับภาพสินค้า ภาพโซเชียล ภาพถ่ายท่องเที่ยว และภาพเก่า.",
            "keywords": "ลบข้อความจากรูปภาพ, ลบลายน้ำ, ลบวันที่จากภาพ, ลบโลโก้จากภาพ, AI inpainting, แต่งรูปสินค้า, WeryAI",
            "howto": {
                "name": "วิธีลบข้อความออกจากรูปภาพออนไลน์",
                "step1": {
                    "name": "อัปโหลดรูปภาพ",
                    "text": "อัปโหลดรูปที่มีข้อความ ลายน้ำ วันที่ หรือโลโก้"
                },
                "step2": {
                    "name": "มาร์กบริเวณที่ต้องการลบ",
                    "text": "ใช้ตัวแก้ไขเพื่อระบุบริเวณข้อความที่ต้องการลบ เพื่อให้ AI ทำงานได้แม่นยำขึ้น"
                },
                "step3": {
                    "name": "ลบข้อความและซ่อมพื้นหลัง",
                    "text": "คลิกสร้าง แล้ว AI จะลบข้อความพร้อมซ่อมพื้นหลังให้ดูเรียบเนียนเป็นธรรมชาติ"
                }
            },
            "og_title": "ลบข้อความออกจากรูปภาพด้วย AI ฟรี | WeryAI",
            "og_description": "ลบข้อความ ลายน้ำ วันที่ และโลโก้ออกจากรูปภาพด้วย AI พร้อมซ่อมพื้นหลังให้ดูกลมกลืน เหมาะกับภาพสินค้า ภาพโซเชียล ภาพถ่ายท่องเที่ยว และภาพเก่า.",
            "twitter_title": "ลบข้อความออกจากรูปภาพด้วย AI ฟรี | WeryAI",
            "twitter_description": "ลบข้อความ ลายน้ำ วันที่ และโลโก้ออกจากรูปภาพด้วย AI พร้อมซ่อมพื้นหลังให้ดูกลมกลืน เหมาะกับภาพสินค้า ภาพโซเชียล ภาพถ่ายท่องเที่ยว และภาพเก่า.",
            "app_name": "ลบข้อความออกจากรูปภาพด้วย AI ฟรี",
            "app_desc": "ลบข้อความ ลายน้ำ วันที่ และโลโก้ออกจากรูปภาพด้วย AI พร้อมซ่อมพื้นหลังให้ดูกลมกลืน เหมาะกับภาพสินค้า ภาพโซเชียล ภาพถ่ายท่องเที่ยว และภาพเก่า.",
            "page": {
                "title1": "ลบข้อความ ลายน้ำ และโลโก้ออกจากรูปภาพได้อย่างรวดเร็ว",
                "title2": "ต้องการลบข้อความจากรูปภาพ ลบลายน้ำ หรือลบวันที่บนภาพหรือไม่? WeryAI ใช้ AI inpainting เพื่อซ่อมพื้นหลังให้ดูเป็นธรรมชาติ โดยไม่ทิ้งรอยเบลอให้เสียภาพ.",
                "title3": "ผลลัพธ์ที่ดีกว่า",
                "title4": "ทำไมควรใช้เครื่องมือนี้",
                "feature_title": "ลบลายน้ำและโลโก้ในคลิกเดียว",
                "click_erase": "ลบด้วยคลิกเดียว",
                "percision_erase": "ลบแบบแม่นยำ",
                "video_link_title": "ลิงก์วิดีโอ",
                "direct_link_desc": "วางลิงก์วิดีโอโดยตรงเพื่อประมวลผลออนไลน์",
                "lossless_qua_title": "กู้คืนคุณภาพแบบไม่สูญเสีย",
                "dual_input_modes": "โหมดอินพุตคู่",
                "audio_sync": "ซิงก์เสียง",
                "text_sync": "ข้อความเป็นเสียงพูด",
                "text_sync_tip": "พิมพ์ข้อความ เลือกเสียง AI แล้วให้ตัวละครพูดได้ทันที",
                "audio_sync_tip": "อัปโหลดเสียงพากย์หรือเพลงของคุณเองเพื่อซิงก์ริมฝีปาก",
                "faq": [
                    {
                        "question": "เครื่องมือลบข้อความด้วย AI คืออะไร",
                        "answer": "เป็นเครื่องมือที่ตรวจจับและลบข้อความ ลายน้ำ โลโก้ คำบรรยาย และวันที่บนรูปภาพ จากนั้นซ่อมพื้นหลังด้วย AI ให้ดูสะอาดเป็นธรรมชาติ"
                    },
                    {
                        "question": "จะลบข้อความจากรูปภาพโดยไม่ให้ภาพเบลอได้อย่างไร",
                        "answer": "ใช้เครื่องมือลบข้อความด้วย AI ของ WeryAI แทนการเบลอทับข้อความ AI จะวิเคราะห์พื้นหลังรอบ ๆ และเติมพื้นที่ที่ลบออกอย่างเป็นธรรมชาติ"
                    },
                    {
                        "question": "ลบลายน้ำและโลโก้ได้ไหม",
                        "answer": "ได้ คุณสามารถลบลายน้ำ โลโก้สินค้า ชื่อผู้ใช้ในภาพหน้าจอ คำบรรยาย และข้อความซ้อนทับอื่น ๆ ได้"
                    },
                    {
                        "question": "ลบวันที่บนรูปภาพได้ไหม",
                        "answer": "ได้ วันที่และเวลาเป็นหนึ่งในงานที่พบได้บ่อยที่สุด AI จะตรวจจับตัวเลขและซ่อมพื้นหลังอย่างท้องฟ้า กำแพง ผิวหนัง หรือหญ้าให้กลับมาเป็นธรรมชาติ"
                    },
                    {
                        "question": "ใช้เครื่องมือลบข้อความของ WeryAI ได้ฟรีไหม",
                        "answer": "ได้ ผู้ใช้ใหม่จะได้รับเครดิตฟรีเมื่อสมัครใช้งานโดยไม่ต้องใช้บัตรเครดิต และยังรับเครดิตฟรีเพิ่มได้จากการเช็กอินรายวัน ทำภารกิจ และชวนเพื่อน"
                    }
                ],
                "feature_title1": "ลบลายน้ำและโลโก้ในคลิกเดียว",
                "feature_desc1": "ลบลายน้ำ โลโก้ และข้อความซ้อนทับจากภาพสินค้า ภาพหน้าจอ และครีเอทีฟการตลาด โดยยังคงคุณภาพภาพต้นฉบับไว้",
                "feature_title2": "ลบวันที่และคำบรรยาย",
                "feature_desc2": "ลบวันที่ เวลา คำบรรยาย และชื่อผู้ใช้จากภาพท่องเที่ยว ภาพเก่า ภาพแชต และภาพหน้าปกวิดีโอได้อย่างรวดเร็ว",
                "feature_title3": "AI ซ่อมพื้นหลังให้เนียนเป็นธรรมชาติ",
                "feature_desc3": "WeryAI ไม่ได้แค่เบลอพื้นที่ที่ลบออก แต่ AI จะสร้างพื้นผิวของท้องฟ้า ผนัง เสื้อผ้า หญ้า และรายละเอียดรอบข้างขึ้นใหม่ให้ภาพดูสะอาดและเป็นธรรมชาติ",
                "feature_title4": "ปลอดภัยและเป็นส่วนตัว",
                "feature_desc4": "ไฟล์ที่คุณอัปโหลดจะถูกประมวลผลอย่างปลอดภัยและใช้เฉพาะกับงานปัจจุบันเท่านั้น"
            },
            "faq": [
                {
                    "question": "เครื่องมือลบข้อความด้วย AI คืออะไร",
                    "answer": "เป็นเครื่องมือสำหรับลบข้อความ ลายน้ำ โลโก้ คำบรรยาย และวันที่ พร้อมซ่อมพื้นหลังด้วย AI"
                },
                {
                    "question": "จะลบข้อความจากรูปภาพโดยไม่ให้ภาพเบลอได้อย่างไร",
                    "answer": "AI จะวิเคราะห์พื้นหลังและเติมพื้นที่ที่ลบออกอย่างเป็นธรรมชาติ แทนการใช้เอฟเฟกต์เบลอ"
                },
                {
                    "question": "ลบลายน้ำและโลโก้ได้ไหม",
                    "answer": "ได้ คุณสามารถลบลายน้ำ โลโก้ คำบรรยาย และข้อความซ้อนทับอื่น ๆ ได้"
                }
            ],
            "feature_title1": "ลบลายน้ำและโลโก้ในคลิกเดียว",
            "feature_desc1": "ลบลายน้ำ โลโก้ และข้อความซ้อนทับจากภาพสินค้า ภาพหน้าจอ และครีเอทีฟการตลาด โดยยังคงคุณภาพภาพต้นฉบับไว้",
            "feature_title2": "ลบวันที่และคำบรรยาย",
            "feature_desc2": "ลบวันที่ เวลา คำบรรยาย และชื่อผู้ใช้จากภาพท่องเที่ยว ภาพเก่า ภาพแชต และภาพหน้าปกวิดีโอได้อย่างรวดเร็ว",
            "feature_title3": "AI ซ่อมพื้นหลังให้เนียนเป็นธรรมชาติ",
            "feature_desc3": "WeryAI ไม่ได้แค่เบลอพื้นที่ที่ลบออก แต่ AI จะสร้างพื้นผิวของท้องฟ้า ผนัง เสื้อผ้า หญ้า และรายละเอียดรอบข้างขึ้นใหม่ให้ภาพดูสะอาดและเป็นธรรมชาติ",
            "feature_title4": "ปลอดภัยและเป็นส่วนตัว",
            "feature_desc4": "ไฟล์ที่คุณอัปโหลดจะถูกประมวลผลอย่างปลอดภัยและใช้เฉพาะกับงานปัจจุบันเท่านั้น",
            "textRemoverHowToUseTitle": "วิธีลบข้อความออกจากรูปภาพออนไลน์",
            "textRemoverHowToUseDesc": "เพียง 3 ขั้นตอนง่ายๆ",
            "textRemoverHowToUseStep1Title": "อัปโหลดรูปภาพ",
            "textRemoverHowToUseStep1Desc": "อัปโหลดรูปที่มีข้อความ ลายน้ำ วันที่ หรือโลโก้",
            "textRemoverHowToUseStep2Title": "มาร์กบริเวณที่ต้องการลบ",
            "textRemoverHowToUseStep2Desc": "ใช้ตัวแก้ไขเพื่อระบุบริเวณข้อความที่ต้องการลบ เพื่อให้ AI ทำงานได้แม่นยำขึ้น",
            "textRemoverHowToUseStep3Title": "ลบข้อความและซ่อมพื้นหลัง",
            "textRemoverHowToUseStep3Desc": "คลิกสร้าง แล้ว AI จะลบข้อความพร้อมซ่อมพื้นหลังให้ดูเรียบเนียนเป็นธรรมชาติ"
        }
    },
    "da": {
        "removeTextFromImage": {
            "title": "Gratis AI værktøj til at fjerne tekst fra billeder | WeryAI",
            "description": "Fjern tekst, vandmærker, datostempler og logoer fra billeder med AI. WeryAI genskaber baggrunden naturligt, så du nemt kan rydde op i produktbilleder, screenshots og sociale opslag.",
            "keywords": "fjern tekst fra billede, fjern vandmærke, fjern datostempel, fjern logo fra billede, AI inpainting, billedoprydning, WeryAI",
            "howto": {
                "name": "Sådan fjerner du tekst fra billeder online",
                "step1": {
                    "name": "Upload billede",
                    "text": "Upload et billede med tekst, vandmærke, datostempel eller logo."
                },
                "step2": {
                    "name": "Markér området der skal fjernes",
                    "text": "Markér tekstområdet i editoren, så AI kan arbejde mere præcist."
                },
                "step3": {
                    "name": "Fjern teksten og genskab baggrunden",
                    "text": "Klik på Opret. AI fjerner teksten og genskaber baggrunden naturligt."
                }
            },
            "og_title": "Gratis AI værktøj til at fjerne tekst fra billeder | WeryAI",
            "og_description": "Fjern tekst, vandmærker, datostempler og logoer fra billeder med AI. WeryAI genskaber baggrunden naturligt, så du nemt kan rydde op i produktbilleder, screenshots og sociale opslag.",
            "twitter_title": "Gratis AI værktøj til at fjerne tekst fra billeder | WeryAI",
            "twitter_description": "Fjern tekst, vandmærker, datostempler og logoer fra billeder med AI. WeryAI genskaber baggrunden naturligt, så du nemt kan rydde op i produktbilleder, screenshots og sociale opslag.",
            "app_name": "Gratis AI værktøj til at fjerne tekst fra billeder",
            "app_desc": "Fjern tekst, vandmærker, datostempler og logoer fra billeder med AI. WeryAI genskaber baggrunden naturligt, så du nemt kan rydde op i produktbilleder, screenshots og sociale opslag.",
            "page": {
                "title1": "Fjern tekst, vandmærker og logoer fra billeder hurtigt",
                "title2": "Vil du fjerne tekst fra et billede, slette et vandmærke eller fjerne et datostempel? WeryAI bruger AI inpainting til at genskabe baggrunden naturligt uden slørede områder.",
                "title3": "Bedre resultater",
                "title4": "Hvorfor bruge dette værktøj?",
                "feature_title": "Fjern vandmærker og logoer med ét klik",
                "click_erase": "Fjern med ét klik",
                "percision_erase": "Præcis fjernelse",
                "video_link_title": "Videolink",
                "direct_link_desc": "Indsæt et direkte videolink for at behandle det online",
                "lossless_qua_title": "Tabsfri kvalitetsgendannelse",
                "dual_input_modes": "Dobbelt inputtilstand",
                "audio_sync": "Lydsynkronisering",
                "text_sync": "Tekst til tale",
                "text_sync_tip": "Skriv en tekst, vælg en AI-stemme, og lad karakteren sige den med det samme.",
                "audio_sync_tip": "Upload din egen voiceover eller sang for at synkronisere læberne.",
                "faq": [
                    {
                        "question": "Hvad er et AI-værktøj til tekstfjernelse?",
                        "answer": "Det er et værktøj, der registrerer og fjerner tekst, vandmærker, logoer, undertekster og datostempler i billeder og genskaber baggrunden med AI."
                    },
                    {
                        "question": "Hvordan fjerner jeg tekst uden at gøre billedet sløret?",
                        "answer": "Brug WeryAIs AI-værktøj til tekstfjernelse. I stedet for at sløre området analyserer AI baggrunden og udfylder det fjernede område naturligt."
                    },
                    {
                        "question": "Kan jeg fjerne vandmærker og logoer?",
                        "answer": "Ja. Du kan fjerne produktlogoer, brugernavne i screenshots, vandmærker, undertekster og andre tekstoverlays."
                    },
                    {
                        "question": "Kan jeg fjerne datostempler fra fotos?",
                        "answer": "Ja. Datostempler og klokkeslæt er blandt de mest almindelige brugsscenarier. AI genkender tallene og genskaber himmel, væg, hud eller græs bag dem."
                    },
                    {
                        "question": "Kan jeg bruge WeryAIs AI-tekstfjerner gratis?",
                        "answer": "Ja. Nye brugere får gratis credits ved registrering uden kreditkort. Du kan også få flere credits via dagligt check-in, opgaver og invitationer af venner."
                    }
                ],
                "feature_title1": "Fjern vandmærker og logoer med ét klik",
                "feature_desc1": "Rens produktbilleder, screenshots og markedsføringsmaterialer for vandmærker, logoer og tekst uden at ødelægge den oprindelige billedkvalitet.",
                "feature_title2": "Slet datostempler og undertekster",
                "feature_desc2": "Fjern datoer, tidspunkter, undertekster og brugernavne fra rejsebilleder, gamle fotos, chatscreenshots og videominiaturer.",
                "feature_title3": "AI genskaber baggrunden naturligt",
                "feature_desc3": "WeryAI nøjes ikke med sløring. AI genskaber himmel, vægge, stof, græs og andre teksturer, så resultatet ser rent og naturligt ud.",
                "feature_title4": "Privat og sikker",
                "feature_desc4": "Dine uploadede filer behandles sikkert og bruges kun til den aktuelle opgave."
            },
            "faq": [
                {
                    "question": "Hvad er et AI-værktøj til tekstfjernelse?",
                    "answer": "Et værktøj til at fjerne tekst, vandmærker, logoer, undertekster og datostempler med samtidig AI-genskabelse af baggrunden."
                },
                {
                    "question": "Hvordan fjerner jeg tekst uden at gøre billedet sløret?",
                    "answer": "AI analyserer baggrunden og udfylder området naturligt i stedet for blot at sløre det."
                },
                {
                    "question": "Kan jeg fjerne vandmærker og logoer?",
                    "answer": "Ja. Du kan fjerne vandmærker, logoer, undertekster og andre tekstoverlays."
                }
            ],
            "feature_title1": "Fjern vandmærker og logoer med ét klik",
            "feature_desc1": "Rens produktbilleder, screenshots og markedsføringsmaterialer for vandmærker, logoer og tekst uden at ødelægge den oprindelige billedkvalitet.",
            "feature_title2": "Slet datostempler og undertekster",
            "feature_desc2": "Fjern datoer, tidspunkter, undertekster og brugernavne fra rejsebilleder, gamle fotos, chatscreenshots og videominiaturer.",
            "feature_title3": "AI genskaber baggrunden naturligt",
            "feature_desc3": "WeryAI nøjes ikke med sløring. AI genskaber himmel, vægge, stof, græs og andre teksturer, så resultatet ser rent og naturligt ud.",
            "feature_title4": "Privat og sikker",
            "feature_desc4": "Dine uploadede filer behandles sikkert og bruges kun til den aktuelle opgave.",
            "textRemoverHowToUseTitle": "Sådan fjerner du tekst fra billeder online",
            "textRemoverHowToUseDesc": "Kun 3 enkle trin",
            "textRemoverHowToUseStep1Title": "Upload billede",
            "textRemoverHowToUseStep1Desc": "Upload et billede med tekst, vandmærke, datostempel eller logo.",
            "textRemoverHowToUseStep2Title": "Markér området der skal fjernes",
            "textRemoverHowToUseStep2Desc": "Markér tekstområdet i editoren, så AI kan arbejde mere præcist.",
            "textRemoverHowToUseStep3Title": "Fjern teksten og genskab baggrunden",
            "textRemoverHowToUseStep3Desc": "Klik på Opret. AI fjerner teksten og genskaber baggrunden naturligt."
        }
    },
    "no": {
        "removeTextFromImage": {
            "title": "Gratis AI-verktøy for å fjerne tekst fra bilder | WeryAI",
            "description": "Fjern tekst, vannmerker, datostempler og logoer fra bilder med AI. WeryAI gjenoppbygger bakgrunnen naturlig, perfekt for produktbilder, skjermbilder og innhold til sosiale medier.",
            "keywords": "fjern tekst fra bilde, fjern vannmerke, fjern datostempel, fjern logo fra bilde, AI inpainting, bildeopprydding, WeryAI",
            "howto": {
                "name": "Slik fjerner du tekst fra bilder på nett",
                "step1": {
                    "name": "Last opp bilde",
                    "text": "Last opp et bilde med tekst, vannmerke, datostempel eller logo."
                },
                "step2": {
                    "name": "Marker området som skal fjernes",
                    "text": "Marker tekstområdet i editoren slik at AI kan jobbe mer presist."
                },
                "step3": {
                    "name": "Fjern teksten og gjenoppbygg bakgrunnen",
                    "text": "Klikk på Opprett. AI fjerner teksten og gjenoppbygger bakgrunnen naturlig."
                }
            },
            "og_title": "Gratis AI-verktøy for å fjerne tekst fra bilder | WeryAI",
            "og_description": "Fjern tekst, vannmerker, datostempler og logoer fra bilder med AI. WeryAI gjenoppbygger bakgrunnen naturlig, perfekt for produktbilder, skjermbilder og innhold til sosiale medier.",
            "twitter_title": "Gratis AI-verktøy for å fjerne tekst fra bilder | WeryAI",
            "twitter_description": "Fjern tekst, vannmerker, datostempler og logoer fra bilder med AI. WeryAI gjenoppbygger bakgrunnen naturlig, perfekt for produktbilder, skjermbilder og innhold til sosiale medier.",
            "app_name": "Gratis AI-verktøy for å fjerne tekst fra bilder",
            "app_desc": "Fjern tekst, vannmerker, datostempler og logoer fra bilder med AI. WeryAI gjenoppbygger bakgrunnen naturlig, perfekt for produktbilder, skjermbilder og innhold til sosiale medier.",
            "page": {
                "title1": "Fjern tekst, vannmerker og logoer fra bilder raskt",
                "title2": "Vil du fjerne tekst fra et bilde, slette et vannmerke eller ta bort et datostempel? WeryAI bruker AI inpainting til å gjenoppbygge bakgrunnen naturlig uten uklare områder.",
                "title3": "Bedre resultater",
                "title4": "Hvorfor bruke dette verktøyet?",
                "feature_title": "Fjern vannmerker og logoer med ett klikk",
                "click_erase": "Fjern med ett klikk",
                "percision_erase": "Presis fjerning",
                "video_link_title": "Videolenke",
                "direct_link_desc": "Lim inn en direkte videolenke for å behandle den på nettet",
                "lossless_qua_title": "Gjenoppretting uten kvalitetstap",
                "dual_input_modes": "Dobbel inndatamodus",
                "audio_sync": "Lydsynkronisering",
                "text_sync": "Tekst til tale",
                "text_sync_tip": "Skriv inn tekst, velg en AI-stemme, og la figuren si den med en gang.",
                "audio_sync_tip": "Last opp din egen voiceover eller sang for å synkronisere leppebevegelsene.",
                "faq": [
                    {
                        "question": "Hva er et AI-verktøy for tekstfjerning?",
                        "answer": "Det er et verktøy som oppdager og fjerner tekst, vannmerker, logoer, undertekster og datostempler i bilder og gjenoppbygger bakgrunnen med AI."
                    },
                    {
                        "question": "Hvordan fjerner jeg tekst uten å gjøre bildet uklart?",
                        "answer": "Bruk WeryAIs AI-verktøy for tekstfjerning. I stedet for å sløre området analyserer AI bakgrunnen og fyller inn det fjernede området naturlig."
                    },
                    {
                        "question": "Kan jeg fjerne vannmerker og logoer?",
                        "answer": "Ja. Du kan fjerne produktlogoer, brukernavn i skjermbilder, vannmerker, undertekster og andre tekstoverlays."
                    },
                    {
                        "question": "Kan jeg fjerne datostempler fra bilder?",
                        "answer": "Ja. Datostempler og klokkeslett er blant de vanligste bruksområdene. AI gjenkjenner tallene og gjenoppbygger himmel, vegg, hud eller gress bak dem."
                    },
                    {
                        "question": "Kan jeg bruke WeryAIs AI-tekstfjerner gratis?",
                        "answer": "Ja. Nye brukere får gratis kreditter ved registrering uten kredittkort. Du kan også få flere kreditter gjennom daglig innsjekk, oppgaver og venninvitasjoner."
                    }
                ],
                "feature_title1": "Fjern vannmerker og logoer med ett klikk",
                "feature_desc1": "Rydd opp i produktbilder, skjermbilder og markedsføringsmateriell ved å fjerne vannmerker, logoer og tekst uten å skade original kvalitet.",
                "feature_title2": "Slett datostempler og undertekster",
                "feature_desc2": "Fjern datoer, klokkeslett, undertekster og brukernavn fra reisebilder, gamle bilder, chatskjermbilder og videominiatyrer.",
                "feature_title3": "AI gjenoppbygger bakgrunnen naturlig",
                "feature_desc3": "WeryAI gjør mer enn å sløre. AI gjenoppretter himmel, vegger, stoff, gress og andre teksturer for et rent og naturlig resultat.",
                "feature_title4": "Sikkert og privat",
                "feature_desc4": "Filene du laster opp behandles sikkert og brukes kun til den aktuelle oppgaven."
            },
            "faq": [
                {
                    "question": "Hva er et AI-verktøy for tekstfjerning?",
                    "answer": "Et verktøy for å fjerne tekst, vannmerker, logoer, undertekster og datostempler samtidig som AI gjenoppbygger bakgrunnen."
                },
                {
                    "question": "Hvordan fjerner jeg tekst uten å gjøre bildet uklart?",
                    "answer": "AI analyserer bakgrunnen og fyller området naturlig i stedet for bare å gjøre det uklart."
                },
                {
                    "question": "Kan jeg fjerne vannmerker og logoer?",
                    "answer": "Ja. Du kan fjerne vannmerker, logoer, undertekster og andre tekstoverlays."
                }
            ],
            "feature_title1": "Fjern vannmerker og logoer med ett klikk",
            "feature_desc1": "Rydd opp i produktbilder, skjermbilder og markedsføringsmateriell ved å fjerne vannmerker, logoer og tekst uten å skade original kvalitet.",
            "feature_title2": "Slett datostempler og undertekster",
            "feature_desc2": "Fjern datoer, klokkeslett, undertekster og brukernavn fra reisebilder, gamle bilder, chatskjermbilder og videominiatyrer.",
            "feature_title3": "AI gjenoppbygger bakgrunnen naturlig",
            "feature_desc3": "WeryAI gjør mer enn å sløre. AI gjenoppretter himmel, vegger, stoff, gress og andre teksturer for et rent og naturlig resultat.",
            "feature_title4": "Sikkert og privat",
            "feature_desc4": "Filene du laster opp behandles sikkert og brukes kun til den aktuelle oppgaven.",
            "textRemoverHowToUseTitle": "Slik fjerner du tekst fra bilder på nett",
            "textRemoverHowToUseDesc": "Kun 3 enkle trinn",
            "textRemoverHowToUseStep1Title": "Last opp bilde",
            "textRemoverHowToUseStep1Desc": "Last opp et bilde med tekst, vannmerke, datostempel eller logo.",
            "textRemoverHowToUseStep2Title": "Marker området som skal fjernes",
            "textRemoverHowToUseStep2Desc": "Marker tekstområdet i editoren slik at AI kan jobbe mer presist.",
            "textRemoverHowToUseStep3Title": "Fjern teksten og gjenoppbygg bakgrunnen",
            "textRemoverHowToUseStep3Desc": "Klikk på Opprett. AI fjerner teksten og gjenoppbygger bakgrunnen naturlig."
        }
    },
    "nl": {
        "removeTextFromImage": {
            "title": "Gratis AI-tool om tekst uit afbeeldingen te verwijderen | WeryAI",
            "description": "Verwijder tekst, watermerken, datumstempels en logo’s uit afbeeldingen met AI. WeryAI herstelt de achtergrond op natuurlijke wijze, ideaal voor productfoto’s, screenshots en social visuals.",
            "keywords": "tekst uit afbeelding verwijderen, watermerk verwijderen, datumstempel verwijderen, logo uit afbeelding verwijderen, AI inpainting, foto opschonen, WeryAI",
            "howto": {
                "name": "Zo verwijder je online tekst uit afbeeldingen",
                "step1": {
                    "name": "Upload afbeelding",
                    "text": "Upload een afbeelding met tekst, watermerk, datumstempel of logo."
                },
                "step2": {
                    "name": "Markeer het gebied dat weg moet",
                    "text": "Markeer in de editor het tekstgebied zodat AI nauwkeuriger kan werken."
                },
                "step3": {
                    "name": "Verwijder tekst en herstel de achtergrond",
                    "text": "Klik op Maken. AI verwijdert de tekst en herstelt de achtergrond op natuurlijke wijze."
                }
            },
            "og_title": "Gratis AI-tool om tekst uit afbeeldingen te verwijderen | WeryAI",
            "og_description": "Verwijder tekst, watermerken, datumstempels en logo’s uit afbeeldingen met AI. WeryAI herstelt de achtergrond op natuurlijke wijze, ideaal voor productfoto’s, screenshots en social visuals.",
            "twitter_title": "Gratis AI-tool om tekst uit afbeeldingen te verwijderen | WeryAI",
            "twitter_description": "Verwijder tekst, watermerken, datumstempels en logo’s uit afbeeldingen met AI. WeryAI herstelt de achtergrond op natuurlijke wijze, ideaal voor productfoto’s, screenshots en social visuals.",
            "app_name": "Gratis AI-tool om tekst uit afbeeldingen te verwijderen",
            "app_desc": "Verwijder tekst, watermerken, datumstempels en logo’s uit afbeeldingen met AI. WeryAI herstelt de achtergrond op natuurlijke wijze, ideaal voor productfoto’s, screenshots en social visuals.",
            "page": {
                "title1": "Verwijder tekst, watermerken en logo’s uit afbeeldingen",
                "title2": "Wil je tekst uit een afbeelding verwijderen, een watermerk wissen of een datumstempel weghalen? WeryAI gebruikt AI inpainting om de achtergrond natuurlijk te herstellen, zonder wazige vlekken.",
                "title3": "Betere resultaten",
                "title4": "Waarom dit hulpmiddel gebruiken?",
                "feature_title": "Verwijder watermerken en logo’s met één klik",
                "click_erase": "Eénklik-verwijdering",
                "percision_erase": "Nauwkeurig verwijderen",
                "video_link_title": "Videolink",
                "direct_link_desc": "Plak een directe videolink om deze online te verwerken",
                "lossless_qua_title": "Kwaliteitsherstel zonder verlies",
                "dual_input_modes": "Dubbele invoermodus",
                "audio_sync": "Audiosynchronisatie",
                "text_sync": "Tekst naar spraak",
                "text_sync_tip": "Typ tekst, kies een AI-stem en laat het personage die direct uitspreken.",
                "audio_sync_tip": "Upload je eigen voice-over of muziek om de lipbewegingen te synchroniseren.",
                "faq": [
                    {
                        "question": "Wat is een AI-tool voor tekstverwijdering?",
                        "answer": "Dit is een tool die tekst, watermerken, logo’s, ondertitels en datumstempels in afbeeldingen detecteert en verwijdert, en daarna de achtergrond met AI herstelt."
                    },
                    {
                        "question": "Hoe verwijder ik tekst zonder dat de afbeelding wazig wordt?",
                        "answer": "Gebruik WeryAI’s AI-tool voor tekstverwijdering. In plaats van tekst met blur te verbergen, analyseert AI de omgeving en vult het verwijderde gebied natuurlijk op."
                    },
                    {
                        "question": "Kan ik watermerken en logo’s verwijderen?",
                        "answer": "Ja. Je kunt productlogo’s, gebruikersnamen in screenshots, watermerken, ondertitels en andere tekstlagen verwijderen."
                    },
                    {
                        "question": "Kan ik datumstempels van foto’s verwijderen?",
                        "answer": "Ja. Datum- en tijdstempels behoren tot de meest voorkomende toepassingen. AI herkent de cijfers en herstelt lucht, muur, huid of gras op de achtergrond."
                    },
                    {
                        "question": "Kan ik WeryAI’s AI-tekstverwijderaar gratis gebruiken?",
                        "answer": "Ja. Nieuwe gebruikers krijgen gratis credits bij registratie zonder creditcard. Je kunt ook extra credits verdienen via dagelijkse check-in, taken en vrienden uitnodigen."
                    }
                ],
                "feature_title1": "Verwijder watermerken en logo’s met één klik",
                "feature_desc1": "Maak productfoto’s, screenshots en marketingbeelden schoon door watermerken, logo’s en tekst te verwijderen zonder kwaliteitsverlies.",
                "feature_title2": "Wis datumstempels en ondertitels",
                "feature_desc2": "Verwijder datums, tijden, ondertitels en gebruikersnamen uit reisfoto’s, oude beelden, chatscreenshots en videominiaturen.",
                "feature_title3": "AI herstelt de achtergrond natuurlijk",
                "feature_desc3": "WeryAI doet meer dan vervagen. AI reconstrueert lucht, muren, stof, gras en andere texturen voor een schoon en natuurlijk resultaat.",
                "feature_title4": "Veilig en privé",
                "feature_desc4": "Je geüploade bestanden worden veilig verwerkt en alleen gebruikt voor de huidige taak."
            },
            "faq": [
                {
                    "question": "Wat is een AI-tool voor tekstverwijdering?",
                    "answer": "Een tool voor het verwijderen van tekst, watermerken, logo’s, ondertitels en datumstempels terwijl de achtergrond met AI wordt hersteld."
                },
                {
                    "question": "Hoe verwijder ik tekst zonder wazigheid?",
                    "answer": "AI analyseert de achtergrond en vult het verwijderde gebied natuurlijk op in plaats van het simpelweg te vervagen."
                },
                {
                    "question": "Kan ik watermerken en logo’s verwijderen?",
                    "answer": "Ja. Je kunt watermerken, logo’s, ondertitels en andere tekstlagen verwijderen."
                }
            ],
            "feature_title1": "Verwijder watermerken en logo’s met één klik",
            "feature_desc1": "Maak productfoto’s, screenshots en marketingbeelden schoon door watermerken, logo’s en tekst te verwijderen zonder kwaliteitsverlies.",
            "feature_title2": "Wis datumstempels en ondertitels",
            "feature_desc2": "Verwijder datums, tijden, ondertitels en gebruikersnamen uit reisfoto’s, oude beelden, chatscreenshots en videominiaturen.",
            "feature_title3": "AI herstelt de achtergrond natuurlijk",
            "feature_desc3": "WeryAI doet meer dan vervagen. AI reconstrueert lucht, muren, stof, gras en andere texturen voor een schoon en natuurlijk resultaat.",
            "feature_title4": "Veilig en privé",
            "feature_desc4": "Je geüploade bestanden worden veilig verwerkt en alleen gebruikt voor de huidige taak.",
            "textRemoverHowToUseTitle": "Zo verwijder je online tekst uit afbeeldingen",
            "textRemoverHowToUseDesc": "Slechts 3 eenvoudige stappen",
            "textRemoverHowToUseStep1Title": "Upload afbeelding",
            "textRemoverHowToUseStep1Desc": "Upload een afbeelding met tekst, watermerk, datumstempel of logo.",
            "textRemoverHowToUseStep2Title": "Markeer het gebied dat weg moet",
            "textRemoverHowToUseStep2Desc": "Markeer in de editor het tekstgebied zodat AI nauwkeuriger kan werken.",
            "textRemoverHowToUseStep3Title": "Verwijder tekst en herstel de achtergrond",
            "textRemoverHowToUseStep3Desc": "Klik op Maken. AI verwijdert de tekst en herstelt de achtergrond op natuurlijke wijze."
        }
    },
    "id": {
        "removeTextFromImage": {
            "title": "Alat AI Gratis untuk Menghapus Teks dari Gambar | WeryAI",
            "description": "Hapus teks, watermark, cap tanggal, dan logo dari gambar dengan AI. WeryAI membangun ulang latar belakang secara alami, cocok untuk foto produk, screenshot, dan materi media sosial.",
            "keywords": "hapus teks dari gambar, hapus watermark, hapus cap tanggal, hapus logo dari gambar, AI inpainting, bersihkan foto, WeryAI",
            "howto": {
                "name": "Cara menghapus teks dari gambar secara online",
                "step1": {
                    "name": "Unggah gambar",
                    "text": "Unggah gambar yang berisi teks, watermark, cap tanggal, atau logo."
                },
                "step2": {
                    "name": "Tandai area yang ingin dihapus",
                    "text": "Tandai area teks di editor agar AI bisa bekerja lebih presisi."
                },
                "step3": {
                    "name": "Hapus teks dan bangun ulang latar",
                    "text": "Klik Buat. AI menghapus teks dan membangun ulang latar belakang secara alami."
                }
            },
            "og_title": "Alat AI Gratis untuk Menghapus Teks dari Gambar | WeryAI",
            "og_description": "Hapus teks, watermark, cap tanggal, dan logo dari gambar dengan AI. WeryAI membangun ulang latar belakang secara alami, cocok untuk foto produk, screenshot, dan materi media sosial.",
            "twitter_title": "Alat AI Gratis untuk Menghapus Teks dari Gambar | WeryAI",
            "twitter_description": "Hapus teks, watermark, cap tanggal, dan logo dari gambar dengan AI. WeryAI membangun ulang latar belakang secara alami, cocok untuk foto produk, screenshot, dan materi media sosial.",
            "app_name": "Alat AI Gratis untuk Menghapus Teks dari Gambar",
            "app_desc": "Hapus teks, watermark, cap tanggal, dan logo dari gambar dengan AI. WeryAI membangun ulang latar belakang secara alami, cocok untuk foto produk, screenshot, dan materi media sosial.",
            "page": {
                "title1": "Hapus teks, watermark, dan logo dari gambar dengan cepat",
                "title2": "Ingin menghapus teks dari gambar, membersihkan watermark, atau menghapus cap tanggal? WeryAI memakai AI inpainting untuk membangun ulang latar belakang secara alami tanpa bekas blur yang mengganggu.",
                "title3": "Hasil yang lebih baik",
                "title4": "Mengapa menggunakan alat ini?",
                "feature_title": "Hapus watermark dan logo sekali klik",
                "click_erase": "Hapus sekali klik",
                "percision_erase": "Hapus presisi",
                "video_link_title": "Tautan video",
                "direct_link_desc": "Tempel tautan video langsung untuk memprosesnya secara online",
                "lossless_qua_title": "Pemulihan kualitas tanpa kehilangan",
                "dual_input_modes": "Mode input ganda",
                "audio_sync": "Sinkronisasi audio",
                "text_sync": "Teks ke suara",
                "text_sync_tip": "Ketik teks, pilih suara AI, lalu biarkan karakter langsung mengucapkannya.",
                "audio_sync_tip": "Unggah sulih suara atau lagu Anda sendiri untuk menyinkronkan gerakan bibir.",
                "faq": [
                    {
                        "question": "Apa itu alat AI penghapus teks?",
                        "answer": "Ini adalah alat yang mendeteksi dan menghapus teks, watermark, logo, subtitle, dan cap tanggal dari gambar, lalu membangun ulang latar belakang dengan AI."
                    },
                    {
                        "question": "Bagaimana cara menghapus teks tanpa membuat gambar blur?",
                        "answer": "Gunakan alat AI penghapus teks dari WeryAI. Alih-alih menutup teks dengan blur, AI menganalisis area sekitar dan mengisi ulang bagian yang dihapus secara alami."
                    },
                    {
                        "question": "Bisakah saya menghapus watermark dan logo?",
                        "answer": "Ya. Anda bisa menghapus logo produk, nama pengguna pada screenshot, watermark, subtitle, dan overlay teks lainnya."
                    },
                    {
                        "question": "Bisakah saya menghapus cap tanggal dari foto?",
                        "answer": "Ya. Cap tanggal dan waktu adalah salah satu penggunaan paling umum. AI mengenali angka dan memulihkan langit, dinding, kulit, atau rumput di belakangnya."
                    },
                    {
                        "question": "Bisakah saya menggunakan alat AI penghapus teks WeryAI secara gratis?",
                        "answer": "Ya. Pengguna baru mendapatkan kredit gratis saat mendaftar tanpa kartu kredit. Anda juga bisa memperoleh kredit tambahan melalui check-in harian, menyelesaikan tugas, dan mengundang teman."
                    }
                ],
                "feature_title1": "Hapus watermark dan logo sekali klik",
                "feature_desc1": "Bersihkan watermark, logo, dan lapisan teks dari foto produk, screenshot, dan materi pemasaran tanpa merusak kualitas gambar asli.",
                "feature_title2": "Hapus cap tanggal dan subtitle",
                "feature_desc2": "Buang tanggal, waktu, subtitle, dan nama pengguna dari foto perjalanan, gambar lama, screenshot chat, dan thumbnail video.",
                "feature_title3": "AI membangun ulang latar belakang",
                "feature_desc3": "WeryAI tidak hanya memburamkan area yang dihapus. AI merekonstruksi langit, dinding, kain, rumput, dan tekstur lain agar hasil akhir terlihat rapi dan alami.",
                "feature_title4": "Aman dan privat",
                "feature_desc4": "File yang Anda unggah diproses dengan aman dan hanya digunakan untuk tugas saat ini."
            },
            "faq": [
                {
                    "question": "Apa itu alat AI penghapus teks?",
                    "answer": "Alat untuk menghapus teks, watermark, logo, subtitle, dan cap tanggal sambil membangun ulang latar belakang dengan AI."
                },
                {
                    "question": "Bagaimana cara menghapus teks tanpa membuat gambar blur?",
                    "answer": "AI menganalisis latar belakang dan mengisi area yang dibersihkan secara alami, bukan sekadar memburamkannya."
                },
                {
                    "question": "Bisakah saya menghapus watermark dan logo?",
                    "answer": "Ya. Anda bisa menghapus watermark, logo, subtitle, dan overlay teks lainnya."
                }
            ],
            "feature_title1": "Hapus watermark dan logo sekali klik",
            "feature_desc1": "Bersihkan watermark, logo, dan lapisan teks dari foto produk, screenshot, dan materi pemasaran tanpa merusak kualitas gambar asli.",
            "feature_title2": "Hapus cap tanggal dan subtitle",
            "feature_desc2": "Buang tanggal, waktu, subtitle, dan nama pengguna dari foto perjalanan, gambar lama, screenshot chat, dan thumbnail video.",
            "feature_title3": "AI membangun ulang latar belakang",
            "feature_desc3": "WeryAI tidak hanya memburamkan area yang dihapus. AI merekonstruksi langit, dinding, kain, rumput, dan tekstur lain agar hasil akhir terlihat rapi dan alami.",
            "feature_title4": "Aman dan privat",
            "feature_desc4": "File yang Anda unggah diproses dengan aman dan hanya digunakan untuk tugas saat ini.",
            "textRemoverHowToUseTitle": "Cara menghapus teks dari gambar secara online",
            "textRemoverHowToUseDesc": "Hanya 3 langkah sederhana",
            "textRemoverHowToUseStep1Title": "Unggah gambar",
            "textRemoverHowToUseStep1Desc": "Unggah gambar yang berisi teks, watermark, cap tanggal, atau logo.",
            "textRemoverHowToUseStep2Title": "Tandai area yang ingin dihapus",
            "textRemoverHowToUseStep2Desc": "Tandai area teks di editor agar AI bisa bekerja lebih presisi.",
            "textRemoverHowToUseStep3Title": "Hapus teks dan bangun ulang latar",
            "textRemoverHowToUseStep3Desc": "Klik Buat. AI menghapus teks dan membangun ulang latar belakang secara alami."
        }
    },
    "tr": {
        "removeTextFromImage": {
            "title": "AI ile Görselden Metin Kaldırma | WeryAI",
            "description": "Görsellerdeki metinleri, filigranları, tarih damgalarını ve logoları AI ile kaldırın. WeryAI arka planı doğal biçimde yeniden oluşturur; ürün görselleri, ekran görüntüleri ve sosyal medya içerikleri için idealdir.",
            "keywords": "görselden metin kaldırma, filigran kaldırma, tarih damgası kaldırma, görselden logo kaldırma, AI inpainting, fotoğraf temizleme, WeryAI",
            "howto": {
                "name": "Görsellerden çevrimiçi metin kaldırma",
                "step1": {
                    "name": "Görsel yükleyin",
                    "text": "Metin, filigran, tarih damgası veya logo içeren görseli yükleyin."
                },
                "step2": {
                    "name": "Kaldırılacak alanı işaretleyin",
                    "text": "Editörde metin alanını işaretleyin; böylece AI daha hassas çalışır."
                },
                "step3": {
                    "name": "Metni kaldırın ve arka planı yeniden oluşturun",
                    "text": "Oluştur’a tıklayın. AI metni kaldırır ve arka planı doğal biçimde yeniden oluşturur."
                }
            },
            "og_title": "AI ile Görselden Metin Kaldırma | WeryAI",
            "og_description": "Görsellerdeki metinleri, filigranları, tarih damgalarını ve logoları AI ile kaldırın. WeryAI arka planı doğal biçimde yeniden oluşturur; ürün görselleri, ekran görüntüleri ve sosyal medya içerikleri için idealdir.",
            "twitter_title": "AI ile Görselden Metin Kaldırma | WeryAI",
            "twitter_description": "Görsellerdeki metinleri, filigranları, tarih damgalarını ve logoları AI ile kaldırın. WeryAI arka planı doğal biçimde yeniden oluşturur; ürün görselleri, ekran görüntüleri ve sosyal medya içerikleri için idealdir.",
            "app_name": "AI ile Görselden Metin Kaldırma",
            "app_desc": "Görsellerdeki metinleri, filigranları, tarih damgalarını ve logoları AI ile kaldırın. WeryAI arka planı doğal biçimde yeniden oluşturur; ürün görselleri, ekran görüntüleri ve sosyal medya içerikleri için idealdir.",
            "page": {
                "title1": "Görsellerden metin, filigran ve logo kaldırın",
                "title2": "Bir görselden metin kaldırmak, filigranı silmek veya tarih damgasını temizlemek mi istiyorsunuz? WeryAI, AI inpainting ile arka planı doğal biçimde yeniden oluşturarak bulanık izler bırakmadan temiz sonuç verir.",
                "title3": "Daha iyi sonuçlar",
                "title4": "Bu aracı neden kullanmalısınız?",
                "feature_title": "Filigran ve logoları tek tıkla kaldırın",
                "click_erase": "Tek tıkla sil",
                "percision_erase": "Hassas silme",
                "video_link_title": "Video bağlantısı",
                "direct_link_desc": "Çevrimiçi işlemek için doğrudan video bağlantısını yapıştırın",
                "lossless_qua_title": "Kayıpsız kalite onarımı",
                "dual_input_modes": "Çift giriş modu",
                "audio_sync": "Ses senkronizasyonu",
                "text_sync": "Metinden konuşma",
                "text_sync_tip": "Metni yazın, bir AI sesi seçin ve karakterin bunu anında söylemesini sağlayın.",
                "audio_sync_tip": "Dudak hareketlerini senkronize etmek için kendi dublajınızı veya şarkınızı yükleyin.",
                "faq": [
                    {
                        "question": "AI metin kaldırma aracı nedir?",
                        "answer": "Bu araç, görsellerdeki metinleri, filigranları, logoları, altyazıları ve tarih damgalarını algılar, kaldırır ve arka planı AI ile yeniden oluşturur."
                    },
                    {
                        "question": "Görseli bulanıklaştırmadan metin nasıl kaldırılır?",
                        "answer": "WeryAI’nin AI metin kaldırma aracını kullanın. Metni blur ile kapatmak yerine AI çevreyi analiz eder ve silinen alanı doğal biçimde tamamlar."
                    },
                    {
                        "question": "Filigran ve logo kaldırabilir miyim?",
                        "answer": "Evet. Ürün görsellerindeki logoları, ekran görüntülerindeki kullanıcı adlarını, filigranları, altyazıları ve diğer metin katmanlarını kaldırabilirsiniz."
                    },
                    {
                        "question": "Fotoğraftaki tarih damgasını kaldırabilir miyim?",
                        "answer": "Evet. Tarih ve saat damgaları en yaygın kullanım senaryolarından biridir. AI rakamları algılar ve arkadaki gökyüzünü, duvarı, cildi veya çimi yeniden oluşturur."
                    },
                    {
                        "question": "WeryAI’nin AI metin kaldırma aracını ücretsiz kullanabilir miyim?",
                        "answer": "Evet. Yeni kullanıcılar kayıt sırasında kredi kartı gerekmeksizin ücretsiz kredi alır. Ayrıca günlük giriş, görev tamamlama ve arkadaş davetiyle daha fazla ücretsiz kredi kazanabilirsiniz."
                    }
                ],
                "feature_title1": "Filigran ve logoları tek tıkla kaldırın",
                "feature_desc1": "Ürün görselleri, ekran görüntüleri ve pazarlama materyallerindeki filigran, logo ve metin katmanlarını orijinal kaliteyi bozmadan temizleyin.",
                "feature_title2": "Tarih damgalarını ve altyazıları silin",
                "feature_desc2": "Seyahat fotoğrafları, eski görüntüler, sohbet ekran görüntüleri ve video küçük resimlerindeki tarih, saat, altyazı ve kullanıcı adlarını kaldırın.",
                "feature_title3": "AI arka planı doğal şekilde yeniden oluşturur",
                "feature_desc3": "WeryAI sadece bulanıklaştırmaz. AI, gökyüzü, duvar, kumaş, çim ve diğer dokuları yeniden oluşturarak temiz ve doğal bir sonuç verir.",
                "feature_title4": "Güvenli ve özel",
                "feature_desc4": "Yüklediğiniz dosyalar güvenli şekilde işlenir ve yalnızca mevcut görev için kullanılır."
            },
            "faq": [
                {
                    "question": "AI metin kaldırma aracı nedir?",
                    "answer": "Metinleri, filigranları, logoları, altyazıları ve tarih damgalarını kaldırırken arka planı AI ile yeniden oluşturan bir araçtır."
                },
                {
                    "question": "Görseli bulanıklaştırmadan metin nasıl kaldırılır?",
                    "answer": "AI arka planı analiz eder ve temizlenen alanı bulanıklaştırmak yerine doğal biçimde doldurur."
                },
                {
                    "question": "Filigran ve logo kaldırabilir miyim?",
                    "answer": "Evet. Filigranları, logoları, altyazıları ve diğer metin katmanlarını kaldırabilirsiniz."
                }
            ],
            "feature_title1": "Filigran ve logoları tek tıkla kaldırın",
            "feature_desc1": "Ürün görselleri, ekran görüntüleri ve pazarlama materyallerindeki filigran, logo ve metin katmanlarını orijinal kaliteyi bozmadan temizleyin.",
            "feature_title2": "Tarih damgalarını ve altyazıları silin",
            "feature_desc2": "Seyahat fotoğrafları, eski görüntüler, sohbet ekran görüntüleri ve video küçük resimlerindeki tarih, saat, altyazı ve kullanıcı adlarını kaldırın.",
            "feature_title3": "AI arka planı doğal şekilde yeniden oluşturur",
            "feature_desc3": "WeryAI sadece bulanıklaştırmaz. AI, gökyüzü, duvar, kumaş, çim ve diğer dokuları yeniden oluşturarak temiz ve doğal bir sonuç verir.",
            "feature_title4": "Güvenli ve özel",
            "feature_desc4": "Yüklediğiniz dosyalar güvenli şekilde işlenir ve yalnızca mevcut görev için kullanılır.",
            "textRemoverHowToUseTitle": "Görsellerden çevrimiçi metin kaldırma",
            "textRemoverHowToUseDesc": "Yalnızca 3 basit adım",
            "textRemoverHowToUseStep1Title": "Görsel yükleyin",
            "textRemoverHowToUseStep1Desc": "Metin, filigran, tarih damgası veya logo içeren görseli yükleyin.",
            "textRemoverHowToUseStep2Title": "Kaldırılacak alanı işaretleyin",
            "textRemoverHowToUseStep2Desc": "Editörde metin alanını işaretleyin; böylece AI daha hassas çalışır.",
            "textRemoverHowToUseStep3Title": "Metni kaldırın ve arka planı yeniden oluşturun",
            "textRemoverHowToUseStep3Desc": "Oluştur’a tıklayın. AI metni kaldırır ve arka planı doğal biçimde yeniden oluşturur."
        }
    }
}
